let upsellSwiper;
  function add_to_cart_grid(variantid,qty,select){
    
    var id = $(".prd"+select).find(':selected').attr('value');

    var q = qty;
    var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + id,
        dataType: "json",
        success: function (n) {
          /*var cart = new theme.CartDrawer
          cart.init()
          cart.open();*/
          updateCartTotal();
          if(jQuery('.drawer.cart__drawer').find('.common-loader-atc').length>0){
            jQuery('.drawer.cart__drawer').find('.common-loader-atc').hide();
          }
          var element = document.querySelector(".hideswitchupsell");
          if (element !== null) {
            document.querySelector('.hideswitchupsell').style.display = "block";
          }
        },
        error: function (n, c) {
           console.log('fail');
        }
     };
    jQuery.ajax(ajax)
    document.querySelector(".prd"+select).selectedIndex =1;
  }

function add_to_cart_grid2(variantid,qty,select){
    //console.log(variantid);
    var id = $(".prd"+select).find(':selected').attr('value');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
    'event': 'atc_1'
    });
    var q = qty;
    var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + variantid,
        dataType: "json",
        success: function (n) {
          /*var cart = new theme.CartDrawer
          cart.init()
          cart.open();*/
          updateCartTotal();
          if(jQuery('.drawer.cart__drawer').find('.common-loader-atc').length>0){
            jQuery('.drawer.cart__drawer').find('.common-loader-atc').hide();
          }
          var element = document.querySelector(".hideswitchupsell");
          if (element !== null) {
            document.querySelector('.hideswitchupsell').style.display = "block";
          }
        },
        error: function (n, c) {
           console.log('fail');
        }
     };
    jQuery.ajax(ajax)
    document.querySelector(".prd"+select).selectedIndex =1;
  }
jQuery(document).on('click','.product-block.buy-atc .add-to-cart',function(e){
  e.preventDefault();
  var variantId = jQuery(this).parent().find('select[name="id"]').find('option:selected').val();
  if(variantId!="" && variantId!=undefined){
    jQuery(this).addClass('btn--loading');
    //console.log("variantId",variantId);
    add_to_cart_grid3(variantId,1);
  }
});

function add_to_cart_grid3(variantid, qty){

  qty = qty || 1;

  var itemArr = [];

  /* -----------------------------
     CREATE UNIQUE BUNDLE ID
  ----------------------------- */
  var bundleId = 'BUNDLE_' + Date.now();

  /* -----------------------------
     MAIN PRODUCT
  ----------------------------- */
  itemArr.push({
    id: variantid,
    quantity: qty,
    properties: {
      _bundle_id: bundleId,
      _is_bundle_parent: "true"
    }
  });


  /* -----------------------------
     UPSELL PRODUCT
  ----------------------------- */
  if(jQuery('.page-content--product')
      .find('.upsell_product.common_upsell_pdp')
      .is(':visible')){

    var variantUpsellId =
      jQuery('.template-product')
      .find('.upsell_product_add')
      .val();

    if(variantUpsellId){
      itemArr.push({
        id: variantUpsellId,
        quantity: 1,
        properties:{
          _parent_bundle: bundleId,
          _is_bundle_child: "true",   // FIX: yeh missing tha
          _bundle: true
        }
      });
    }
  }


  /* -----------------------------
     BUNDLE ACCESSORIES
  ----------------------------- */
  if(bundleActiveVersion()){

    if(jQuery('#strap_accessories').is(":checked")){

      var selectedAccessories = preparePDPBundle();
      var accessoryProps = {};
      var bundle_image='';
      var bundle_title = '';
      var bundle_description='';
      
      if(Array.isArray(selectedAccessories) && selectedAccessories.length){
        if(jQuery('.product_bundle_selector').find('.bundle_mt_fields').val()!=""){
          bundle_description=jQuery('.product_bundle_selector').find('.bundle_mt_fields').val();
        }
        if(jQuery('.product_bundle_selector').find('.bundle_mt_fields').attr('bundle-title')!=""){
          bundle_title=jQuery('.product_bundle_selector').find('.bundle_mt_fields').attr('bundle-title');
        }
        if(jQuery('.product_bundle_selector').find('.bundle_mt_fields').attr('bundle-title')!=""){
          bundle_image=jQuery('.product_bundle_selector').find('.bundle_mt_fields').attr('bundle-image');
        }

        if (bundle_image && bundle_image.trim()) {
          accessoryProps._bundle_image = String(bundle_image);
        }

        if (bundle_title && bundle_title.trim()) {
          accessoryProps._bundle_title = String(bundle_title);
        }

        if (bundle_description && bundle_description.trim()) {
          accessoryProps._bundle_description = String(bundle_description);
        }

        for(var d=0; d<selectedAccessories.length; d++){
          var accessoriesHandle = selectedAccessories[d].variant_handle;
          accessoryProps['_Item ' + (d+1)] =
            selectedAccessories[d].product_title+'#@#'+selectedAccessories[d].variant_name+'#@#'+selectedAccessories[d].variant_image+'#@#'+selectedAccessories[d].variant_price+'#@#'+selectedAccessories[d].variant_handle;

          itemArr.push({
            id: selectedAccessories[d].variant_id,
            quantity: qty,
            properties:{
              _bundle: true,
              _is_bundle_child: "true",
              _parent_bundle: bundleId
            }
          });
        }

        // attach readable props to main product
        itemArr[0].properties =
          Object.assign(itemArr[0].properties, accessoryProps);
      }
    }
  }


  /* -----------------------------
     AJAX ADD TO CART
  ----------------------------- */

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify({ items: itemArr }),

    success: function () {

      updateCartTotal();

      jQuery('.common-loader-atc').hide();
      jQuery('.add-to-cart').removeClass('btn--loading');

      jQuery('.upsell_checkbox').prop("checked",false);
      jQuery('.upsell_btn').removeClass("upsell_added");
      jQuery('.upsell_product_add').val('');

    },

    error: function () {
      console.log('fail');
    }
  });
}

function syncBundleItems(){
  fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    let updates = {};
    
    cart.items.forEach(function(item, mainIndex){
      if(item.properties && item.properties._is_bundle_parent === 'true'){
        let bundleId = item.properties._bundle_id;
        let mainQty = item.quantity;

        cart.items.forEach(function(child, childIndex){
          if(
            child.properties &&
            child.properties._parent_bundle == bundleId
          ){
            let lineNumber = parseInt(childIndex) + 1;

            if(child.quantity !== mainQty){
              updates[lineNumber] = mainQty;
            }
          }
        });
      }

      if(item.properties && item.properties._parent_bundle){
        let parentBundleId = item.properties._parent_bundle;
        let parentExists = cart.items.some(function(i){
          return i.properties &&
                 i.properties._bundle_id == parentBundleId &&
                 i.properties._is_bundle_parent === 'true';
        });

        if(!parentExists){
          updates[parseInt(mainIndex) + 1] = 0;
        }
      }
    });

    if(Object.keys(updates).length){
      let lineUpdates = {};
      Object.keys(updates).forEach(function(lineNum){
        let idx = parseInt(lineNum) - 1;
        let item = cart.items[idx];
        if(item){
          lineUpdates[item.key] = updates[lineNum];
        }
      });
      
      fetch('/cart/update.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ updates: lineUpdates })
      })
      .then(res => res.json())
      .then(function(updatedCart){
        var totalCents = updatedCart.total_price;
        var totalDollars = (totalCents / 100).toFixed(2);
        var priceCartTotal = Shopify.formatMoney(totalDollars);
        if(jQuery('.cart__item__subtotal').find('.ajaxcart__totalprice div').length>0){
          jQuery('.cart__item__subtotal').find('.ajaxcart__totalprice div').text(priceCartTotal);
        }
        document.dispatchEvent(new Event('cart:updated'));
        
      })
      .catch(function(err){
        console.error('Cart update error:', err);
      });
    }
  });
}
function removeBundleChildren(bundleId){

  fetch('/cart.js')
  .then(r=>r.json())
  .then(cart=>{

    let updates = {};

    // FIX: item.key ki jagah line number (index + 1) use karo
    cart.items.forEach(function(item, index){
      if(
        item.properties &&
        item.properties._parent_bundle == bundleId
      ){
        updates[index + 1] = 0;   // FIX: item.key kaam nahi karta
      }
    });

    fetch('/cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({updates})
    });

  });
}



$(document).on("click", "#shipping_protection", function(){
  let variantid = $(this).data("variant");
  if($('#shipping_protection').is(':checked')){
    
    var q = 1;
    var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + variantid,
        dataType: "json",
        success: function (n) {
          /*var cart = new theme.CartDrawer
          cart.init()
          cart.open();*/
          updateCartTotal();
          if(jQuery('.drawer.cart__drawer').find('.common-loader-atc').length>0){
            jQuery('.drawer.cart__drawer').find('.common-loader-atc').hide();
          }
        },
        error: function (n, c) {
           console.log('fail');
        }
     };
    jQuery.ajax(ajax)
    
  }else{

    var q = 0;
    var ajax = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + q + "&id=" + variantid,
        dataType: "json",
        success: function (n) {
          /*var cart = new theme.CartDrawer
          cart.init()
          cart.open();*/
          updateCartTotal();
          if(jQuery('.drawer.cart__drawer').find('.common-loader-atc').length>0){
            jQuery('.drawer.cart__drawer').find('.common-loader-atc').hide();
          }
        },
        error: function (n, c) {
           console.log('fail');
        }
     };
    jQuery.ajax(ajax)
    
  }
});

function add_remove_from_cart_grid(variantid){
  var getajax = {
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      success: function (n) {
        jQuery.each(n.items, function(key, val){
          console.log(val.variant_id);
          if(val.variant_id == variantid){
            
            var q = 0;
            var ajax = {
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + q + "&id=" + variantid,
                dataType: "json",
                success: function (n) {
                  /*var cart = new theme.CartDrawer
                  cart.init()
                  cart.open();*/
                  updateCartTotal();
                  if(jQuery('.drawer.cart__drawer').find('.common-loader-atc').length>0){
                    jQuery('.drawer.cart__drawer').find('.common-loader-atc').hide();
                  }
                },
                error: function (n, c) {
                   console.log('fail');
                }
             };
            jQuery.ajax(ajax)
            
          }else{
            
            var q = 1;
            var ajax = {
                type: "POST",
                url: "/cart/add.js",
                data: "quantity=" + q + "&id=" + variantid,
                dataType: "json",
                success: function (n) {
                  /*var cart = new theme.CartDrawer
                  cart.init()
                  cart.open();*/
                  updateCartTotal();
                  if(jQuery('.drawer.cart__drawer').find('.common-loader-atc').length>0){
                    jQuery('.drawer.cart__drawer').find('.common-loader-atc').hide();
                  }
                },
                error: function (n, c) {
                   console.log('fail');
                }
             };
            jQuery.ajax(ajax)
            
          }
        });
      },
      error: function (n, c) {
         console.log('fail');
      }
   };
  jQuery.ajax(getajax);
}


/*  start cart drawer upsell  */
$(document).on("click", "#cart_drawer_upsell_1", function(){
  let variantid = '47342803288351';//$(this).data("variant");
  if($('#cart_drawer_upsell_1').is(':checked')){
    var cookieKey = 'cartUpsell5';
    localStorage.setItem(cookieKey, variantid);
    
    var q = 1;
    var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + variantid,
        dataType: "json",
        success: function (n) {
          /*var cart = new theme.CartDrawer
          cart.init()
          cart.open();*/
          updateCartTotal();
          if(jQuery('.drawer.cart__drawer').find('.common-loader-atc').length>0){
            jQuery('.drawer.cart__drawer').find('.common-loader-atc').hide();
          }

          $('#cart_drawer_upsell_new').html('');
        },
        error: function (n, c) {
           console.log('fail');
        }
     };
    jQuery.ajax(ajax)
    
  }
});

$(document).on("click", "#cart_drawer_upsell_2", function(){
  let variantid = '47342803288351';//$(this).data("variant");
  if($('#cart_drawer_upsell_2').is(':checked')){
    var cookieKey = 'cartUpsell5';
    localStorage.setItem(cookieKey, variantid);
    var q = 1;
    var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + variantid,
        dataType: "json",
        success: function (n) {
          /*var cart = new theme.CartDrawer
          cart.init()
          cart.open();*/
          updateCartTotal();
          if(jQuery('.drawer.cart__drawer').find('.common-loader-atc').length>0){
            jQuery('.drawer.cart__drawer').find('.common-loader-atc').hide();
          }

          $('#cart_drawer_upsell_new').html('');
        },
        error: function (n, c) {
           console.log('fail');
        }
     };
    jQuery.ajax(ajax)
  }
});
/*  end cart drawer upsell  */

/* product details page watch cover add to cart start here */
$(document).on("click", ".cover-btn-cart", function(){
  //let variantid = jQuery(this).attr("data-vid");
  let variantid = jQuery(this).parent().find('.cover_variant_box').find('.cover_variant_selector option:selected').val();
  console.log("variantid---", variantid);
  let productId = jQuery(this).attr("data-pid");
  if(variantid!="" && variantid!=undefined){
    var q = 1;
    var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + variantid,
        dataType: "json",
        success: function (n) {
          /*var cart = new theme.CartDrawer
          cart.init()
          cart.open();*/
          updateCartTotal();
          if(jQuery('.drawer.cart__drawer').find('.common-loader-atc').length>0){
            jQuery('.drawer.cart__drawer').find('.common-loader-atc').hide();
          }
          jQuery('[data-pid="'+productId+'"]'+'.watch-cover-card').hide();
        },
        error: function (n, c) {
           console.log('fail');
        }
     };
    jQuery.ajax(ajax)
  }
});

$(document).on("change", ".cover_variant_selector", function(){
  var element = $(this).find('option:selected'); 
  var vimg = element.attr("data-img");
  var pid = element.attr("data-pid");
  console.log('vimg-->', vimg);
  $('.cover_img_'+pid).attr('src', vimg);
});

/* product details page watch cover add to cart end here */

/* product grid add to cart code */
$(".add__btn_custom").click(function () {
  $(this).hide();
  $(this).parent().find(".add__custom_loader").show();
  var pid = parseInt($(this).attr("data-vid"));

  var dataType = [];
  var data = {};
  data["id"] = parseInt($(this).attr("data-vid"));
  data["quantity"] = 1;
  dataType.push(data);
  const newData = {
    items: dataType,
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: newData,
    dataType: "json",
    success: function (data) {
      /*setTimeout(function () {
        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();
      }, 1550);*/
      updateCartTotal();
      if(jQuery('.drawer.cart__drawer').find('.common-loader-atc').length>0){
        jQuery('.drawer.cart__drawer').find('.common-loader-atc').hide();
      }
    },
  });

  /*setTimeout(function () {
    $(".add__btn_custom").show();
    $(".add__custom_loader").hide();
    jQuery('[cart-product--id="' + pid + '"]').hide();
  }, 1550);*/
});

jQuery(document).on("change",".add__select_custom",function () {
  var productId = jQuery(this).parent('div').attr('data-product-id');
  var selectObj = $(this);
  selectObj.hide();
  //$(this).parent().find(".add__custom_loader").show();
  var loaderObj = $(this).parent().find('.common-loader-atc');
  loaderObj.show();
  var dataType = [];
  var data = {};
  data["id"] = parseInt($(this).val());
  data["quantity"] = 1;
  dataType.push(data);
  const newData = {
    items: dataType,
  };
  $(this).val("");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: newData,
    dataType: "json",
    success: function (data) {
      //setTimeout(function () {
      setTimeout(function(){
        selectObj.show();
        //$(this).parent().find(".add__custom_loader").hide();
        loaderObj.hide();
      },100);
        /*var cart = new theme.CartDrawer();
        cart.init();
        cart.open();*/
        updateCartTotal();
        offerCodeHtml(1);
        //defaultShowProgress();
        if(productId!=undefined){
          jQuery('[cart-product--id="'+productId+'"]').hide();
        }
      //}, 1550);
    },
  });

  /*setTimeout(function () {
    $(".add__select_custom").show();
    $(".add__custom_loader").hide();
  }, 1550);*/
});
/* product grid add to cart code */

/************************ CART DRAWER JS START ***********************/
$(document).on('click','.cart__drawer .js-qty__adjust--plus',function (e) {
  updatecartQuantity($(this), 1);
  setTimeout(function(){
    syncBundleItems();
  },700);

});

$(document).on('click', '.cart__drawer .js-qty__adjust--minus', function () {

  const upsellSection = jQuery('.cart__drawer .custom--section--upsells');

  const isUpsellVisible = upsellSection.css('display') === 'block';
  console.log("isUpsellVisible",isUpsellVisible);
  if (isUpsellVisible) {
    updatecartQuantity($(this), 0);
  } else if (!$(this).hasClass('js-qty__adjust--trash')) {
    updatecartQuantity($(this), -1);
  }else if($(this).parent().hasClass('bundle_remove')) {
    updatecartQuantity($(this),0);
  }else{
    var getquantity = $(this).parent().find('.js-qty__num').val();
    if(getquantity==1){
      updatecartQuantity($(this), 0);
    }else if(getquantity>1){
      updatecartQuantity($(this), -1);
    }
  }
  setTimeout(function(){
    syncBundleItems();
  },700);
});
jQuery(document).ready(function(){
  updateCartTotal(1);
  defaultShowProgress();
});

document.addEventListener('cart:updated', function(){
  syncBundleItems();
});

function defaultShowProgress(){
   var defaultProgress = 0;
  if(jQuery('.offer-box-wrapper.code-bogo-offer-vcommon').length>0){
    jQuery('.offer-box-wrapper.code-bogo-offer-vcommon').hide();
  }
  if(jQuery('body.offer-box-wrapper-v1').length>0){
    defaultProgress=1;
  }else if(jQuery('body.offer-box-wrapper-v2').length>0){
    defaultProgress=1;
  }else if(jQuery('body.offer-box-wrapper-v3').length>0){
    defaultProgress=1;
  }
  //console.log("defaultShowProgress",defaultProgress);
  if(defaultProgress==1 && jQuery('.cart__drawer').find('.multi-step-form-default').length>0){
    jQuery('.cart__drawer').find('.multi-step-form-default').removeAttr('style');
  }
}

function updatecartQuantity($el, change) {
  jQuery('.cart__drawer').find('.common-loader-atc.btn--loading').show();
  var $wrapper = $el.parent().find('.js-qty__num');
  var $input = $wrapper;
  if(jQuery('body').hasClass('bundle_selector_vone') || jQuery('body').hasClass('bundle_selector_vtwo') || jQuery('body').hasClass('bundle_selector_vthree')){
    var line = $wrapper.data('cartvid');
  }else{
    var line = $wrapper.data('id');
  }
  var dataKey = $wrapper.data('id');
  if(change!=0){
    var newQty = parseInt($input.val()) + change;
    if (newQty < 1) newQty = 1;
  }else{
    var newQty=0;
  }
  if(change==0){
    jQuery('.cart__drawer').find('.cart__item[data-key="'+dataKey+'"]').remove();
  }
  if(newQty>1){
    $el.parent().find('.quantity-trash').hide();
    $el.parent().find('.icon.icon-minus').show();
    $el.removeClass('js-qty__adjust--trash');
  }else{
    $el.parent().find('.quantity-trash').show();
    $el.parent().find('.icon.icon-minus').hide();
    $el.addClass('js-qty__adjust--trash');
  }
  if(jQuery('body.offer-box-wrapper-v4').find('.main-delivery--progress-wrapper').length>0){
    if(jQuery('.multi-step-form-bogo-offer').length>0){
      jQuery('.multi-step-form-bogo-offer').show();
    }
  }
  // Shopify AJAX update
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      id: line,
      quantity: newQty
    },
    dataType: 'json',
    success: function (cart) {
      $input.val(newQty);

      updateCartTotal();
      offerCodeHtml();

      // FIX: Yahan syncBundleItems call karo — cart already update ho chuka hai
      syncBundleItems();

      setTimeout(function(){
        jQuery('.cart__drawer').find('.common-loader-atc.btn--loading').hide();
      },100);
      setTimeout(function(){
        initUpsellSwiper();
      },500);
    },
    error: function (err) {
      setTimeout(function(){
        jQuery('.cart__drawer').find('.common-loader-atc.btn--loading').hide();
      }, 100);
      setTimeout(function(){
        initUpsellSwiper();
      },500);
      //alert(err.responseJSON.description);
    }
  });
}
$(document).on('click','.cart__drawer .js-qty__wrapper .js-qty__adjust--trash',function () {
  /*var interIdDrawer = setInterval(function(){
    if(!jQuery('html').hasClass('js-drawer-open')){
      jQuery('html').addClass('js-drawer-open');
      jQuery('.drawer.cart__drawer').addClass('drawer--is-open');
      jQuery('.drawer.cart__drawer').attr('tabindex','-1');
      jQuery('.main-content').addClass('has-after');
      jQuery('body').addClass('drawer--is-open'); 
      clearInterval(interIdDrawer);
    }
  });
  if(jQuery('.drawer.cart__drawer').find('.cart__item').length==1){
    jQuery('.cart__drawer').find('.drawer__cart-empty').show();
    jQuery('.drawer.cart__drawer').addClass('is-empty');
    jQuery('.cart__drawer').find('.drawer__inner').hide();
    //jQuery('.main-content').removeClass('has-after');
    jQuery('html').removeClass('js-drawer-open');
    $('.drawer.cart__drawer').find('.bogo-apex-3.appear--animation').hide();
  }*/
  updatecartQuantity($(this), 0);
});

function cartUpsellHtml(){
  var cartDrawerUpsell = "";
  cartDrawerUpsell +=
    '<div class="cart_checkbox_1" style="display: none;" product--id="8843064738079">';
  cartDrawerUpsell += '<div class="cart_inner_checkbox">';
  cartDrawerUpsell += '<div class="cart_checkbox_img">';
  cartDrawerUpsell +=
    '<img src="//prettystraps.com/cdn/shop/files/MyPrettyStrap-Packaging-Set-1-1080x1080.jpg?v=1701955709" width="100">';
  cartDrawerUpsell += "</div>";
  cartDrawerUpsell += '<div class="check_inner_titlebox">';
  cartDrawerUpsell +=
    "<p>Premium Gift Box <span class=“money”>$14.99</span></p>";
  cartDrawerUpsell += "</div>";
  cartDrawerUpsell += "</div>";
  cartDrawerUpsell += '<div class="cart_main_check">';
  cartDrawerUpsell += '<div class="psrelated-check">';
  cartDrawerUpsell +=
    '<input type="checkbox" id="cart_drawer_upsell_1" class="shipping_protection" data-gtm-form-interact-field-id="0">';
  cartDrawerUpsell +=
    '<label for="cart_drawer_upsell_1" class="checkbox-input">';
  cartDrawerUpsell += "</label>";
  cartDrawerUpsell += "</div>";
  cartDrawerUpsell += "</div>";
  cartDrawerUpsell += "</div>";
  cartDrawerUpsell +=
    '<div class="cart_checkbox_2" style="display: none;" product--id="8843064738079">';
  cartDrawerUpsell += '<div class="cart_inner_checkbox">';
  cartDrawerUpsell += '<div class="check_with_title">';
  cartDrawerUpsell += '<div class="check_inner_checkbox">';
  cartDrawerUpsell +=
    '<input type="checkbox" id="cart_drawer_upsell_2" class="shipping_protection" data-gtm-form-interact-field-id="0">';
  cartDrawerUpsell +=
    '<label for="cart_drawer_upsell_2" class="checkbox-input"></label>';
  cartDrawerUpsell += "</div>";
  cartDrawerUpsell += '<div class="check_inner_img">';
  cartDrawerUpsell +=
    '<img src="//prettystraps.com/cdn/shop/files/MyPrettyStrap-Packaging-Set-1-1080x1080.jpg?v=1701955709" width="100">';
  cartDrawerUpsell += "</div>";
  cartDrawerUpsell += '<div class="check_inner_title">';
  cartDrawerUpsell += "<h6>Premium Gift Box</h6>";
  cartDrawerUpsell += "<span>The perfect gift set for you</span>";
  cartDrawerUpsell += "</div>";
  cartDrawerUpsell += "</div>";
  cartDrawerUpsell += '<div class="check_inner_price">';
  cartDrawerUpsell +=
    '<span class="check_main_price money">$14.99</span>';
  cartDrawerUpsell +=
    '<span class="check_compare_price  hide money"></span>';
  cartDrawerUpsell += "</div>";
  cartDrawerUpsell += "</div>";
  cartDrawerUpsell += "</div>";
  $("#cart_drawer_upsell_new").html(cartDrawerUpsell);
}

function offerCodeHtml(flagchange){
  $.ajax({
    url: "/cart",
    dataType: "json",
    error: function (items) {
      //console.error(items[0]);
      //loadingBarTrigger("done");
    },
    success: function (cart) {
      $(".custom--upsell-item").removeClass("hide");
      //jQuery('body').addClass('offer-box-wrapper-v1');
      let upsell_1ID = $(".upsell_1_id").attr("product--id");
      let upsell_2ID = $(".upsell_2_id").attr("product--id");
      let upsell_3ID = $(".upsell_3_id").attr("product--id");
      let upsell_4ID = $(".upsell_4_id").attr("product--id");
      let mainCartItems = cart.items;
      var totalCartitem = mainCartItems.length;
      let original_total_price = cart.original_total_price;
      let items_subtotal_price = cart.items_subtotal_price;

      let found_package_in_cart = false;
      let line_item_id = null;
      let chkFlashCode = "";
      let chkFlashCodeTitle = "";
      let chkDiscountType = "";
      var strapCheck = 0;
      var productCount = 0;
      var countItems = 0; 
      let roseGoldPrice=0;
      let cartCancerAmount=0;
      let mainCancerAmount=(2.75*100);
      console.log("cart.items",cart.items.length,cart.items);
      for (var i = 0; i < mainCartItems.length; i++) {
        if (mainCartItems[i].discounts.length > 0) {
          for (var d = 0; d < mainCartItems[i].discounts.length; d++) {
            if (mainCartItems[i].discounts[d].title == "FLASH24" || mainCartItems[i].discounts[d].title == 'BOGO-FLASH') {
              chkDiscountType = "1";
            }
            if (mainCartItems[i].discounts[d].title == "B2G3FLASH" || mainCartItems[i].discounts[d].title == 'B2G3-FLASH') {
              chkDiscountType = "2";
            }
            if (mainCartItems[i].discounts[d].title == "B3G4FLASH" || mainCartItems[i].discounts[d].title == 'B3G4-FLASH') {
              chkDiscountType = "3";
            }
            if (
              mainCartItems[i].discounts[d].title == "FLASH24" ||
              mainCartItems[i].discounts[d].title == "B2G3FLASH" ||
              mainCartItems[i].discounts[d].title == "B3G4FLASH" ||
              mainCartItems[i].discounts[d].title == "BOGO-FLASH" ||
              mainCartItems[i].discounts[d].title == "B2G3-FLASH" ||
              mainCartItems[i].discounts[d].title == "B3G4-FLASH"
            ) {
              chkFlashCode = 1;
              chkFlashCodeTitle = mainCartItems[i].discounts[d].title;
            }
          }
        }
        if (mainCartItems[i] != undefined) {
          var productTitle = mainCartItems[i].title.toLowerCase();
          if(productTitle && productTitle.includes('strap') && !productTitle.includes('strap bag')) {
            strapCheck = 1;
            productCount+=mainCartItems[i].quantity;
          }
        }

        if(mainCartItems[i].variant_title!=undefined){
          var variantTitle = mainCartItems[i].variant_title.toLowerCase();
          if(variantTitle!=undefined){
            if(variantTitle && variantTitle.includes('rose gold')) {
              roseGoldPrice+=(parseFloat(mainCartItems[i].discounted_price) * parseFloat(mainCartItems[i].quantity));
              mainCancerAmount=(mainCancerAmount);
              cartCancerAmount+=(mainCancerAmount*mainCartItems[i].quantity);
            }
          }
        }
        //console.log(mainCartItems[i],upsell_1ID,upsell_2ID,upsell_3ID);
        line_item_id = mainCartItems[i].product_id;
        if (
          line_item_id == upsell_1ID ||
          line_item_id == upsell_2ID ||
          line_item_id == upsell_3ID ||
          line_item_id == upsell_4ID
        ) {
          $(
            ".custom--upsell-item[product--id=" + line_item_id + "]"
          ).addClass("hide");
        }
        countItems++;
        console.log("totalCartitem",totalCartitem,productCount);
        console.log("countItems",countItems);
        if(totalCartitem == countItems){
          /* For BOGO snnippet product page */
          $(".bf_progressbar_list").removeClass(
            "bf_progressbar_list_complate_one"
          );
          $(".bf_progressbar_list").removeClass(
            "bf_progressbar_list_complate"
          );
          $("#bogo_sn1_v3").prop("checked", false);
          $("#bogo_sn2_v3").prop("checked", false);
          $("#bogo_sn3_v3").prop("checked", false);
          if (chkDiscountType == 1) {
            $("#bogo_sn1_v3").prop("checked", true);
            $(".bf_progressbar_list_v1").addClass(
              "bf_progressbar_list_complate_one"
            );
          }
          if (chkDiscountType == 2) {
            $("#bogo_sn1_v3").prop("checked", true);
            $("#bogo_sn2_v3").prop("checked", true);
            $(".bf_progressbar_list_v1").addClass(
              "bf_progressbar_list_complate_one"
            );
            $(".bf_progressbar_list_v1").addClass(
              "bf_progressbar_list_complate"
            );
            $(".bf_progressbar_list_v2").addClass(
              "bf_progressbar_list_complate_one"
            );
          }
          if (chkDiscountType == 3) {
            $("#bogo_sn1_v3").prop("checked", true);
            $("#bogo_sn2_v3").prop("checked", true);
            $("#bogo_sn3_v3").prop("checked", true);
            $(".bf_progressbar_list_v1").addClass(
              "bf_progressbar_list_complate_one"
            );
            $(".bf_progressbar_list_v1").addClass(
              "bf_progressbar_list_complate"
            );
            $(".bf_progressbar_list_v2").addClass(
              "bf_progressbar_list_complate_one"
            );
            $(".bf_progressbar_list_v2").addClass(
              "bf_progressbar_list_complate"
            );
            $(".bf_progressbar_list_v3").addClass(
              "bf_progressbar_list_complate_one"
            );
          }
          /* For BOGO snnippet product page */
          console.log("chkFlashCodeTitle",chkFlashCodeTitle,chkFlashCode);
          if(chkFlashCode == 1) {
            var discountLable = "BUY 1 GET 1 FREE COUPON APPLIED";
            var discountLable2 = "BUY 1 GET 1 FREE";
            if (chkFlashCodeTitle == "B2G3FLASH" || chkFlashCodeTitle == "B2G3-FLASH" || chkFlashCodeTitle == "B2G3" ) {
              discountLable = "BUY 2 GET 3 FREE COUPON APPLIED";
              discountLable2 = "BUY 2 GET 3 FREE";
            } else if (chkFlashCodeTitle == "B3G4FLASH" || chkFlashCodeTitle == "B3G4-FLASH" || chkFlashCodeTitle == "B3G4" ) {
              discountLable = "BUY 3 GET 4 FREE COUPON APPLIED";
              discountLable2 = "BUY 3 GET 4 FREE";
            }
            var cartDiscountStyle3 =
              '<div class="cart__discounts cart__item-sub cart__item-row">';
            cartDiscountStyle3 += '<div class="discount__info text-right">';
            cartDiscountStyle3 += '<div class="cart__discount Discounts">';
            cartDiscountStyle3 +=
              '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">';
            cartDiscountStyle3 +=
              '<path d="M3.3125 15.7109C3.3125 16.0221 3.56387 16.2734 3.875 16.2734H8.90234V9.66406H3.3125V15.7109ZM10.0977 16.2734H15.125C15.4361 16.2734 15.6875 16.0221 15.6875 15.7109V9.66406H10.0977V16.2734ZM15.9688 5.44531H13.3742C13.6133 5.06914 13.7539 4.62266 13.7539 4.14453C13.7539 2.80684 12.6658 1.71875 11.3281 1.71875C10.6004 1.71875 9.94473 2.04219 9.5 2.55195C9.05527 2.04219 8.39961 1.71875 7.67188 1.71875C6.33418 1.71875 5.24609 2.80684 5.24609 4.14453C5.24609 4.62266 5.38496 5.06914 5.62578 5.44531H3.03125C2.72012 5.44531 2.46875 5.69668 2.46875 6.00781V8.46875H8.90234V5.44531H10.0977V8.46875H16.5312V6.00781C16.5312 5.69668 16.2799 5.44531 15.9688 5.44531ZM8.90234 5.375H7.67188C6.99336 5.375 6.44141 4.82305 6.44141 4.14453C6.44141 3.46602 6.99336 2.91406 7.67188 2.91406C8.35039 2.91406 8.90234 3.46602 8.90234 4.14453V5.375ZM11.3281 5.375H10.0977V4.14453C10.0977 3.46602 10.6496 2.91406 11.3281 2.91406C12.0066 2.91406 12.5586 3.46602 12.5586 4.14453C12.5586 4.82305 12.0066 5.375 11.3281 5.375Z" fill="white"></path>';
            cartDiscountStyle3 += "</svg>";
            cartDiscountStyle3 += "<span>" + discountLable + "</span>";
            cartDiscountStyle3 += "</div>";
            cartDiscountStyle3 += "</div>";
            cartDiscountStyle3 += "</div>";

            $(".cartitem-discount-v3").html("");
            $(".cartitem-discount-v3").append(cartDiscountStyle3);

            var cartDiscountStyle1 =
              '<div class="cart__discounts cart__item-sub cart__item-row">';
            cartDiscountStyle1 += '<div class="discount__info text-right">';
            cartDiscountStyle1 += '<div class="cart__discount">';
            cartDiscountStyle1 +=
              '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">';
            cartDiscountStyle1 +=
              '<path d="M5.86208 9.62424L1.375 5.13715V6.43424L5.86208 10.9213L10.0054 6.77799L9.35458 6.13174L5.86208 9.62424Z" fill="#D2A741"></path>';
            cartDiscountStyle1 +=
              '<path d="M1.375 4.14333L5.86208 8.63042L10.0054 4.48708L5.51833 0H1.375V4.14333ZM3.32292 1.375C3.47486 1.375 3.62059 1.43536 3.72803 1.5428C3.83547 1.65025 3.89583 1.79597 3.89583 1.94792C3.89583 2.09986 3.83547 2.24559 3.72803 2.35303C3.62059 2.46047 3.47486 2.52083 3.32292 2.52083C3.17097 2.52083 3.02525 2.46047 2.9178 2.35303C2.81036 2.24559 2.75 2.09986 2.75 1.94792C2.75 1.79597 2.81036 1.65025 2.9178 1.5428C3.02525 1.43536 3.17097 1.375 3.32292 1.375Z" fill="#D2A741"></path>';
            cartDiscountStyle1 += "</svg>";
            cartDiscountStyle1 +=
              "DISCOUNT <span>" + discountLable2 + "</span> APPLIED";
            cartDiscountStyle1 += "</div>";
            cartDiscountStyle1 += "</div>";
            cartDiscountStyle1 += "</div>";

            $(".cartitem-discount-v1").html("");
            $(".cartitem-discount-v1").append(cartDiscountStyle1);
            
            var cartDiscountStyle2 =
              '<div class="cart__discounts cart__item-sub cart__item-row">';
            cartDiscountStyle2 +=
              '<div class="discount__title">Discounts</div>';
            cartDiscountStyle2 += '<div class="discount__info text-right">';
            cartDiscountStyle2 += '<div class="cart__discount">';
            cartDiscountStyle2 +=
              '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">';
            cartDiscountStyle2 +=
              '<path d="M5.86208 9.62424L1.375 5.13715V6.43424L5.86208 10.9213L10.0054 6.77799L9.35458 6.13174L5.86208 9.62424Z" fill="#D2A741"></path>';
            cartDiscountStyle2 +=
              '<path d="M1.375 4.14333L5.86208 8.63042L10.0054 4.48708L5.51833 0H1.375V4.14333ZM3.32292 1.375C3.47486 1.375 3.62059 1.43536 3.72803 1.5428C3.83547 1.65025 3.89583 1.79597 3.89583 1.94792C3.89583 2.09986 3.83547 2.24559 3.72803 2.35303C3.62059 2.46047 3.47486 2.52083 3.32292 2.52083C3.17097 2.52083 3.02525 2.46047 2.9178 2.35303C2.81036 2.24559 2.75 2.09986 2.75 1.94792C2.75 1.79597 2.81036 1.65025 2.9178 1.5428C3.02525 1.43536 3.17097 1.375 3.32292 1.375Z" fill="#D2A741"></path>';
            cartDiscountStyle2 += "</svg>";
            cartDiscountStyle2 += discountLable2;
            cartDiscountStyle2 += "</div>";
            cartDiscountStyle2 += "</div>";
            cartDiscountStyle2 += "</div>";

            $(".cartitem-discount-v2").html("");
            $(".cartitem-discount-v2").append(cartDiscountStyle2);

            var cookieKey = "freeProductId";
            var freeProductId = localStorage.getItem(cookieKey);
          
            var cartUpsell5Id = localStorage.getItem("cartUpsell5");
          
            if (cartUpsell5Id == "47342803288351") {
              localStorage.setItem("cartUpsell5", "");
              cartUpsellHtml();
            }
            
            if (freeProductId == "47266105983263" && cart.items.length == 1) {
              removeUpsellProduct()();
            } else {
              if (cart.item_count > 0) {
                jQuery('.drawer.cart__drawer').removeClass("is-empty");
              } else {
                jQuery('.drawer.cart__drawer').addClass("is-empty");
              }
            }
          }
          /****************************************************
           * MPS-65 STRAP START OF PROGRESSBAR 
          ****************************************************/
            let freeShippingPrice = parseInt(jQuery('body').attr('data-shipping-goal'));
            let freeShippingProgressTarget = parseInt(jQuery('body').attr('data-shipping-goal'));

            let subtotal = (items_subtotal_price/100);

            var conversionRate = Shopify.currency.rate || 1;
            freeShippingProgressTarget = Math.round(freeShippingProgressTarget * conversionRate);

            //console.log("freeShippingProgressTarget",freeShippingProgressTarget);
            let freeship = Math.round((subtotal * 100) / freeShippingProgressTarget);
            if (freeship > 100) freeship = 100;

            /* ------------------------- V1,V2: Initialization ------------------------- */
            if((jQuery('body').hasClass('offer-box-wrapper-v2'))){
              jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.first-card').removeClass('unlock');
              var defaultProgress = 0;
              if(jQuery('.offer-box-wrapper.code-bogo-offer-vcommon').length>0){
                jQuery('.offer-box-wrapper.code-bogo-offer-vcommon').hide();
              }
              if(jQuery('body.offer-box-wrapper-v2').find('.offer-box-wrapper').length>0){
                objFlash = jQuery('body.offer-box-wrapper-v2').find('.offer-box-wrapper.code-bogo-offer-vcommon');
                jQuery('.cart__drawer').find('.offer-box-wrapper.code-bogo-offer-vcommon').removeClass('hidden-bogo');
                defaultProgress=1;
              }
              var goal1 = 2;
              var goal2 = 5;
              var goal3 = 7;
              var freeBogoText = '';
              var freeBottomText = 'Buy 1, Get 1 FREE';
              var subBottomText = 'unlock BOGO';
              if (strapCheck == 1) {
                objFlash.show();
                var discountFlashBuy = "1";
                var discountFlashFree = " 1 "; 
                var discountMoreStrap = 1;
                var discountStraps = 1;
                freeBogoText = 'BUY 1 GET 1 FREE';
                if(productCount >= 2 && productCount < 5){
                  discountFlashBuy = "2";
                  discountFlashFree = " 3 "; 
                  var remaincount = (goal2 - productCount);
                  discountMoreStrap = remaincount;
                  discountStraps = remaincount;
                  if(freeship>=100){
                    freeBogoText = 'BUY 2 GET 3 FREE';
                  }else{
                    freeBogoText = 'FREE SHIPPING';
                  }
                  freeBottomText = 'Buy 2, Get 3 FREE';
                  subBottomText = 'unlock B2G3';
                } else if (productCount >= 5 && productCount < 7) {
                  discountFlashBuy = "3";
                  discountFlashFree = " 4 "; 
                  var remaincount = (goal3 - productCount);
                  discountMoreStrap = remaincount;
                  discountStraps = remaincount;
                  freeBogoText = 'BUY 3 GET 4 FREE';
                  freeBottomText = 'Buy 3, Get 4 FREE';
                  subBottomText = 'unlock B3G4';
                } else if(productCount >= 7){
                  discountFlashBuy = "";
                  discountFlashFree = ""; 
                  discountMoreStrap = '';
                  discountStraps = '';
                  freeBogoText = '';
                  freeBottomText = '';
                  subBottomText = '';
                }

                if(discountMoreStrap != ""){
                  if(discountMoreStrap > 1){
                    discountMoreStrap = parseInt(discountMoreStrap) + ' more straps';
                  } else {
                    discountMoreStrap = parseInt(discountMoreStrap) + ' more strap';
                  }
                }
                if(productCount == 2 && freeship<100){
                  let remaining = ((freeShippingProgressTarget - subtotal)*100);
                  remaining = Shopify.formatMoney(remaining);
                  remaining=remaining.replace(/.00/g, '');
                  if(jQuery('.offer-cart-msg-bogo-ship .cart-strap-remain').length > 0){
                    jQuery('.offer-cart-msg-bogo-ship .cart-strap-remain').text(remaining);
                  }
                  if(jQuery('.offer-cart-msg-bogo-ship').find('.cart-strap-text-free').length > 0){
                    jQuery('.offer-cart-msg-bogo-ship').find('.cart-strap-text-free').text('FREE SHIPPING');
                  }
                  if(jQuery('.offer-pargh.offer-boxbogo-flash').find('.buttom-text-free').length>0){
                    jQuery('.offer-pargh.offer-boxbogo-flash').find('.buttom-text-free').text('unlock B2G3');
                  }
                  if(jQuery('.offer-box-wrapper .offer-popup').find('.tooltip-strap-count').length>0){
                    jQuery('.offer-box-wrapper .offer-popup').find('.tooltip-strap-count').text('3 more starps');
                  }
                  if(objFlash.find('.offer-pargh.offer-boxbogo-flash').find('strong').length > 0){
                    objFlash.find('.offer-pargh.offer-boxbogo-flash').find('strong').text('3 more starps');
                  }
                  if(jQuery('.offer-box-wrapper .offer-popup').find('.tooltip-strap-msg').length>0){
                    jQuery('.offer-box-wrapper .offer-popup').find('.tooltip-strap-msg').text('unlock B2G3');
                  }
                  if(jQuery('.offer-box-wrapper').find('.text-box.flash-get-free').length>0){
                    jQuery('.offer-box-wrapper').find('.text-box.flash-get-free').text('Buy 2, Get 3 FREE');
                  }
                }else{
                  //console.log("freeBottomText",freeBottomText);
                  if(jQuery('.offer-cart-msg-bogo-ship').find('.cart-strap-text-free').length > 0){
                    jQuery('.offer-cart-msg-bogo-ship').find('.cart-strap-text-free').text(freeBogoText);
                  }
                  if(jQuery('.offer-cart-msg-bogo-ship').find('.cart-strap-remain').length > 0){
                    jQuery('.offer-cart-msg-bogo-ship').find('.cart-strap-remain').text(discountMoreStrap);
                  }
                  if(objFlash.find('.offer-pargh.offer-boxbogo-flash').find('strong').length > 0){
                    objFlash.find('.offer-pargh.offer-boxbogo-flash').find('strong').text(discountMoreStrap);
                  }
                  if(jQuery('.code-bogo-offer-vcommon.offer-box-wrapper').find('.text-box').length > 0){
                    jQuery('.code-bogo-offer-vcommon.offer-box-wrapper').find('.text-box').text(freeBottomText);
                  }
                  if(jQuery('.offer-pargh.offer-boxbogo-flash').find('.buttom-text-free').length>0){
                    jQuery('.offer-pargh.offer-boxbogo-flash').find('.buttom-text-free').text(subBottomText);
                  }
                  if(jQuery('.offer-box-wrapper .offer-popup').find('.tooltip-strap-count').length>0){
                    jQuery('.offer-box-wrapper .offer-popup').find('.tooltip-strap-count').text(discountMoreStrap);
                  }
                  if(jQuery('.offer-box-wrapper .offer-popup').find('.tooltip-strap-msg').length>0){
                    jQuery('.offer-box-wrapper .offer-popup').find('.tooltip-strap-msg').text(subBottomText);
                  }
                }
                if(discountFlashBuy == "" && (jQuery('body.offer-box-wrapper-v1').find('.offer-box-wrapper').length > 0 || jQuery('body.offer-box-wrapper-v2').find('.offer-box-wrapper').length > 0)){
                  objFlash.hide();
                }
                // ── Reset all cards before applying ──────────────────────────
                jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship').removeClass('unlock');
                jQuery('.delivery--progress-wrapper').find('.delivery--progress-card').removeClass('unlock');

                var flagBogo  = 0;
                var goalfreeShip = 0;

                // ── GOAL 0: productCount < 2 ──────────────────────────────────
                if (productCount < goal1) {
                  progressPercent = 0;
                  // No cards unlock
                  jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('show-bogo');
                  jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('hidden-bogo');
                  jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                  jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').hide();
                  flagBogo = 1;
                  goalfreeShip = 1;

                // ── GOAL 1: productCount == 2 ─────────────────────────────────
                } else if (productCount === goal1) {
                  progressPercent = 20;
                  // first-card unlock only
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.first-card').addClass('unlock');

                  if(freeship < 100){
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('show-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('hidden-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').hide();
                  } else if(freeship >= 100){
                    progressPercent = 40;
                    jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.second-card').addClass('unlock');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('hidden-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('show-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').removeAttr('style');
                  }
                  flagBogo = 1;
                  goalfreeShip = 1;

                // ── BETWEEN GOAL1 AND GOAL2: productCount > 2 && < 5 ─────────
                } else if (productCount > goal1 && productCount < goal2) {
                  progressPercent = 40;
                  if(freeship >= 100){
                    progressPercent = 50;
                    if(productCount == 4){
                      progressPercent = 55;
                    }
                  }else if(productCount == 4){
                    progressPercent = 55;
                  }else if (productCount == 5){
                    progressPercent = 60;
                  }
                  // first-card + second-card unlock
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.first-card').addClass('unlock');
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.second-card').addClass('unlock');

                  if(freeship < 100){
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('show-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('hidden-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').show();
                  } else if(freeship >= 100){
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('hidden-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('show-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').removeAttr('style');
                  }
                  flagBogo = 1;

                // ── GOAL2: productCount >= 5 && < 7 ──────────────────────────
                } else if (productCount >= goal2 && productCount < goal3) {
                  progressPercent = 70;
                  if(productCount==6){
                    progressPercent = 80;
                  }
                  // first-card + second-card + third-card unlock
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.first-card').addClass('unlock');
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.second-card').addClass('unlock');
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.third-card').addClass('unlock');

                  if(freeship < 100){
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('show-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('hidden-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').show();
                  } else if(freeship >= 100){
                    // All 4 cards unlock
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('hidden-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('show-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').removeAttr('style');
                  }
                  flagBogo = 1;
                  goalfreeShip = 1;

                // ── GOAL3 WITH DISCOUNT: productCount >= 7 + discount ────────
                } else if (productCount >= goal3 && discountFlashBuy != "") {
                  progressPercent = 90;
                  // first-card + second-card + third-card unlock
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.first-card').addClass('unlock');
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.second-card').addClass('unlock');
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.third-card').addClass('unlock');
                  jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.first-card').addClass('unlock');
                  jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.second-card').addClass('unlock');
                  jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.third-card').addClass('unlock');
                  if(jQuery('body').hasClass('offer-box-wrapper-v4')){
                    jQuery('.multi-step-form-bogo-offer').removeAttr('style');
                  }
                  jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();

                  if(freeship < 100){
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('show-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('hidden-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').hide();
                  } else if(freeship >= 100){
                    // last-card unlock
                    jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.last-card').addClass('unlock');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('hidden-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('show-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').show();
                  }

                // ── GOAL3 NO DISCOUNT: productCount >= 7 + no discount ───────
                } else if (productCount >= goal3 && discountFlashBuy == "") {
                  progressPercent = 100;
                  // All 4 cards unlock
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.first-card').addClass('unlock');
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.second-card').addClass('unlock');
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.third-card').addClass('unlock');
                  jQuery('.bogo-with-shipping-progress').find('.bogo-with-ship.last-card').addClass('unlock');

                  if(freeship < 100){
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('show-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('hidden-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').hide();
                  } else if(freeship >= 100){
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('hidden-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('show-bogo');
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').hide();
                    jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').show();
                  }
                }
                jQuery('.bogo-with-shipping-progress').find('.common-offer-congrats').hide();
                if(productCount>=goal3){
                  if(jQuery('.bogo-with-shipping-progress').find('.congrats-offer-msg').length>0){
                    jQuery('.bogo-with-shipping-progress').find('.congrats-offer-msg').show();
                  }
                }else if(productCount>0){
                  if(jQuery('.bogo-with-shipping-progress').find('.offer-cart-msg-bogo-ship').length>0){
                    jQuery('.bogo-with-shipping-progress').find('.offer-cart-msg-bogo-ship').show();
                  }
                }

                // ── Strap count message ───────────────────────────────────────
                if(discountFlashFree != ""){
                  var bogoMsg = jQuery('.cart__drawer').find('.multi-step-form-bogo-offer');
                  if(bogoMsg != undefined && bogoMsg != ""){
                    if(discountStraps == 1){
                      bogoMsg.find('.bogo-offer-strap.strap-free-text').find('.strap-count-text').text(discountStraps + ' strap');
                    } else {
                      bogoMsg.find('.bogo-offer-strap.strap-free-text').find('.strap-count-text').text(discountStraps + ' straps');
                    }
                  }
                }

                // ── Old single progress bar update ───────────────────────────
                if(jQuery('.cart-progress-wrapper').find('.new_offer_progress').length > 0){
                  jQuery('.cart-progress-wrapper').find('.new_offer_progress').css('width', progressPercent + '%');
                }

                // ── 4 goal progress bar update ───────────────────────────────
                var progressDiscountHeading = '';
                if (chkDiscountType == "1") {
                  progressDiscountHeading = 'Buy 1, Get 1 FREE';
                } else if (chkDiscountType == "2") {
                  progressDiscountHeading = 'Buy 2, Get 3 FREE';
                } else if (chkDiscountType == "3") {
                  progressDiscountHeading = 'Buy 3, Get 4 FREE';
                }
                //cartProgressBar(items_subtotal_price, progressDiscountHeading, 'flagload');

                if(defaultProgress == 1 && jQuery('.cart__drawer').find('.multi-step-form-default').length > 0){
                  jQuery('.cart__drawer').find('.multi-step-form-default').removeAttr('style');
                }

              } // end strapCheck == 1
            }else{
              jQuery('.cart__drawer').find('.multi-step-form-2').show();
            }
            /* ------------------------- V1,V2: END ------------------------- */
          /****************************************************
           * MPS-65 STRAP END OF STRAP PROGRESSBAR
          ****************************************************/

          /****************************************************
           * BREAST CANCER SUPPORT ROSE GOLD PROGRESSBAR START
          ****************************************************/
          if(jQuery('body').hasClass('rose_gold_active')){
            if(jQuery('.rose_gold_active').find('.cancer-support-section').is(':visible')){
              if(jQuery('.rose_gold_active').find('.cancer-support-section').find('.progress-bar-fill').length>0 && roseGoldPrice!=0){
                var getCancerGoal = jQuery('.rose_gold_active').find('.cancer-support-section').find('.goal-amount').attr('data-goal-amount');
                var amountCalc = (roseGoldPrice/100);
                var remaining = getCancerGoal - amountCalc;
                if (remaining < 0) remaining = 0;

                var percent = (amountCalc / getCancerGoal) * 100;
                if (percent > 100) percent = 100;

                percent = Math.round(percent * 100) / 100;
                if(remaining>0){
                  remaining = (remaining*100);
                }
                if(percent<100){
                  jQuery('.rose_gold_active').find('.cancer-support-section').find('.progress-stats').show();
                  jQuery('.rose_gold_active').find('.cancer-support-section').find('.amount-raised').text(Shopify.formatMoney(remaining));
                }else{
                  jQuery('.rose_gold_active').find('.cancer-support-section').find('.progress-stats').hide();
                }
                jQuery('.rose_gold_active').find('.cancer-support-section').find('.progress-bar-fill').css('width',percent+'%');
              }
            }
            if(jQuery('.drawer.cart__drawer').find('.cancer-support-section.cancer-support-cart').is(':visible') && cartCancerAmount!=0){
              jQuery('.drawer.cart__drawer').find('.cancer-support-section.cancer-support-cart').find('.cancer-support-subtitle strong').text(Shopify.formatMoney(cartCancerAmount)); 
            }
          }
          /****************************************************
           * BREAST CANCER SUPPORT ROSE GOLD PROGRESSBAR END
          ****************************************************/
        }
      }
    },
  });
  // End Custom
}

/****************************************************
  * MPS-65 STRAP START OF PROGRESSBAR COMMON
****************************************************/
jQuery(document).on("click",".offer-box-wrapper .offer-button .info-icon",function(e){
  jQuery('.cart__drawer').find('.offer-box-wrapper').find('.offer-popup').toggle();
});
jQuery(document).on("click",".offer-box-wrapper .offer-popup .close-toggle-btn",function(e){
  jQuery('.cart__drawer').find('.offer-box-wrapper').find('.offer-popup').hide();
});
/****************************************************
 * MPS-65 STRAP END OF STRAP PROGRESSBAR COMMON
****************************************************/

function removeUpsellProduct(){
  localStorage.setItem("freeProductId", "");
  var pendingFreeStrap =
    '<div class="product-single__related-free-item free_prod_not_added style-1" style="display:none;">';
  pendingFreeStrap += '<div class="psrelated-item">';
  pendingFreeStrap += '<div class="psrelated-media">';
  pendingFreeStrap +=
    '<img src="https://cdn.shopify.com/s/files/1/0512/7461/2920/files/Text_input_container.png?v=1700719028">';
  pendingFreeStrap += "</div>";
  pendingFreeStrap += '<div class="psrelated-content">';
  pendingFreeStrap +=
    '<h2><span style="color:#ff4f33;">TODAY ONLY:</span> FREE IPHONE STRAP</h2>';
  pendingFreeStrap += '<div class="psrelated-review">';
  pendingFreeStrap += '<div class="psrelated-review-info">';
  pendingFreeStrap +=
    "<span>Fits all iPhone models and cases</span>";
  pendingFreeStrap += "</div>";
  pendingFreeStrap += "</div>";
  pendingFreeStrap += "</div>";
  pendingFreeStrap += '<div class="psrelated-check">';
  pendingFreeStrap +=
    '<input type="checkbox" id="free_minipad" class="shipping_protection" data-gtm-form-interact-field-id="0">';
  pendingFreeStrap +=
    '<label for="free_minipad" class="checkbox-input"> </label>';
  pendingFreeStrap += "</div>";
  pendingFreeStrap += "</div>";
  pendingFreeStrap += "</div>";

  pendingFreeStrap +=
    '<div class="product-single__related-free-item free_prod_not_added style-2" style="display:none;">';
  pendingFreeStrap += '<div class="psrelated-item">';
  pendingFreeStrap += '<div class="psrelated-media">';
  pendingFreeStrap +=
    '<img src="https://cdn.shopify.com/s/files/1/0512/7461/2920/files/Text_input_container.png?v=1700719028">';
  pendingFreeStrap += "</div>";
  pendingFreeStrap += '<div class="psrelated-content">';
  pendingFreeStrap +=
    '<h2><span style="color:#ff4f33;">TODAY ONLY:</span> FREE IPHONE STRAP</h2>';
  pendingFreeStrap += '<div class="psrelated-review">';
  pendingFreeStrap += '<div class="psrelated-review-info">';
  pendingFreeStrap +=
    "<span>Fits all iPhone models and cases</span>";
  pendingFreeStrap += "</div>";
  pendingFreeStrap += "</div>";
  pendingFreeStrap += "</div>";
  pendingFreeStrap += '<div class="psrelated-check">';
  pendingFreeStrap +=
    '<input type="checkbox" id="free__minipad" class="shipping_protection" data-gtm-form-interact-field-id="0">';
  pendingFreeStrap +=
    '<label for="free__minipad" class="checkbox---input"> </label>';
  pendingFreeStrap += "</div>";
  pendingFreeStrap += "</div>";
  pendingFreeStrap += "</div>";

  pendingFreeStrap +=
    '<div class="product-single__related-free-item free_prod_not_added style-3" style="display:none;">';
  pendingFreeStrap +=
    '<input type="checkbox" id="free__minipad_3" checked style="display:none" class="shipping_protection">';
  pendingFreeStrap += '<div class="psrelated-item">';
  pendingFreeStrap += '<div class="psrelated-media">';
  pendingFreeStrap +=
    '<img src="https://cdn.shopify.com/s/files/1/0512/7461/2920/files/Text_input_container.png?v=1700719028">';
  pendingFreeStrap += "</div>";
  pendingFreeStrap += '<div class="psrelated-content">';
  pendingFreeStrap +=
    "<h2><span>GIFT UNLOCKED:</span> FREE IPHONE STRAP</h2>";
  pendingFreeStrap += '<div class="psrelated-review">';
  pendingFreeStrap += '<div class="psrelated-review-info">';
  pendingFreeStrap +=
    "<span>Almost gone - last free straps left in stock!</span>";
  pendingFreeStrap += "</div>";
  pendingFreeStrap += "</div>";
  pendingFreeStrap += "</div>";
  pendingFreeStrap += "</div>";
  pendingFreeStrap += "</div>";

  $("#free_strp_product").html(pendingFreeStrap);
}

function generateHandle(name) {
  return name
    .toLowerCase()                   // lowercase
    .trim()                          // remove leading/trailing spaces
    .replace(/[^a-z0-9\s-]/g, '')    // remove special chars
    .replace(/\s+/g, '-')            // replace spaces with hyphens
    .replace(/-+/g, '-');            // collapse multiple hyphens
}
var drawerPId = setInterval(function(){
  if(jQuery('#cart-items-goals').length>0){
    setShippingGoal();
    clearInterval(drawerPId);
  }
},500);

function setShippingGoal(){
  const el = jQuery('#cart-items-goals');
  const cartTotal = parseFloat(el.attr('data-cart-subtotal')); // remove comma if needed
  cartProgressBar(cartTotal,'discountheading',1);
}

function cartProgressBar(totalPrice,discountheading,flagload=''){
  let freeShippingPrice = jQuery('body').attr('data-shipping-goal');
  let freeShippingProgressTarget = jQuery('body').attr('data-shipping-goal');

  let subtotal = (totalPrice/100);

  var conversionRate = Shopify.currency.rate || 1;
  freeShippingProgressTarget = Math.round(freeShippingProgressTarget * conversionRate);

  //console.log("freeShippingProgressTarget",freeShippingProgressTarget);
  let pricePercentage = Math.round((subtotal * 100) / freeShippingProgressTarget);
  if (pricePercentage > 100) pricePercentage = 100;

  // Update progress bar
  $('.drawer.cart__drawer').find('.progress-segment.segment-1').css({
    width: pricePercentage + '%',
    '--after-content': pricePercentage + '%'
  });
  $('.drawer.cart__drawer').find('.progress-text').text(pricePercentage + '%');

  if (parseFloat(subtotal) < parseFloat(freeShippingProgressTarget)) {
    // Not qualified for free shipping
    $('.drawer.cart__drawer').find('.congrats-msg-n').hide();
    $('.drawer.cart__drawer').find('.cart-rest-msg-n').show();

    let remaining = ((freeShippingProgressTarget - subtotal)*100);
    remaining = Shopify.formatMoney(remaining);
    remaining=remaining.replace(/.00/g, '');
    $('.drawer.cart__drawer').find('.cart-rest-price-n').text(`${remaining}`);
  } else {
    // Qualified for free shipping
    $('.drawer.cart__drawer').find('.congrats-msg-n.common-congrats').show();
    $('.drawer.cart__drawer').find('.cart-rest-msg-n').hide();
  }
  if(flagload==""){
    if(discountheading!=""){
      //console.log("iiiiiii",$('.drawer.cart__drawer').find('.offer-code-section').length);
      //$('.drawer.cart__drawer').find('.offer-code-section').show();
      $('.drawer.cart__drawer').find('.offer-code-section').find('h2').text(discountheading);
    }else if(discountheading==""){
      //$('.drawer.cart__drawer').find('.offer-code-section').hide();    
    }
  }
  bogoOfferShowhide();
  //offerCodeHtml(pricePercentage);
}


// ✅ Add this ABOVE your updateCartTotal function
async function getComparePrice(variantId) {
  if (window.variantPrices && window.variantPrices[variantId]) {
    return window.variantPrices[variantId].compare_at_price || 0;
  }

  try {
    const res = await fetch(`/variants/${variantId}.js`);
    const variant = await res.json();

    window.variantPrices = window.variantPrices || {};
    window.variantPrices[variantId] = {
      price: variant.price,
      compare_at_price: variant.compare_at_price || 0
    };

    return variant.compare_at_price || 0;
  } catch (e) {
    console.error('getComparePrice error:', e);
    return 0;
  }
}


function updateCartTotal(firstload=''){
  //console.log("discountTitle",discountTitle);
  let discountTitle = '';
  
  $.getJSON('/cart.js', async function(cart) {
    var totalCents = cart.total_price; // Shopify returns price in cents
    var totalDollars = (totalCents / 100).toFixed(2);
    var priceCartTotal = Shopify.formatMoney(totalDollars);

    let totalCompare = 0;
    let comparePrices = {};
    let requests = [];

    cart.items.forEach(function(item){
      if(item.original_line_price === item.final_line_price){
        let req = $.getJSON('/products/' + item.handle + '.js', function(product){
          let variant = product.variants.find(v => v.id == item.variant_id);
          if(variant){
            let comparePrice = variant.compare_at_price || variant.price;
            comparePrices[item.variant_id] = comparePrice * item.quantity;
            totalCompare += comparePrice * item.quantity;
          }
        });
        requests.push(req);
      }
    });

    $.when.apply($, requests).then(function(){
      console.log("resqueu",requests);
      if (totalCompare > 0) {
        var savingsHtml =
          theme.Currency.formatMoney(
            (totalCompare - totalCents),
            theme.settings.moneyFormat
          );
        var setComparePrice = theme.Currency.formatMoney(
            (totalCompare),
            theme.settings.moneyFormat
          );
        if(jQuery('.cart__item__subtotal').find('.ajaxcart__totalprice .saving-total').length>0){
          jQuery('.cart__item__subtotal').find('.ajaxcart__totalprice .saving-total').text(`${savingsHtml}`);
        }
        if(jQuery('.cart-checkout-button-box.for-ab-test').find('.checkout-total-compare').length>0){
          jQuery('.cart-checkout-button-box.for-ab-test').find('.checkout-total-compare').text(setComparePrice);
        }
      }
    });
    jQuery('.cart__item__subtotal').find('.ajaxcart__totalprice div').text(`${priceCartTotal}`);
    if(jQuery('.cart-checkout-button-box.for-ab-test').find('.checkout_total_price').length>0){
      jQuery('.cart-checkout-button-box.for-ab-test').find('.checkout_total_price').text(`${priceCartTotal}`);
    }
    
    jQuery('.cart__item__subtotal').find('.ajaxcart__totalprice div').text(`${priceCartTotal}`);
    if(firstload==""){
      if(cart.item_count>=1){
        if(!jQuery('html').hasClass('js-drawer-open')){
          jQuery('html').addClass('js-drawer-open');
          jQuery('.drawer.cart__drawer').addClass('drawer--is-open');
          jQuery('.drawer.cart__drawer').attr('tabindex','-1');
          jQuery('.main-content').addClass('has-after');
          jQuery('body').addClass('drawer--is-open'); 
        }
        jQuery('.header-item.header-item--icons').find('.cart-link__bubble').addClass('cart-link__bubble--visible');
        jQuery('.cart__drawer').find('.drawer__cart-empty').hide();
        jQuery('.drawer.cart__drawer').removeClass('is-empty');
        jQuery('.cart__drawer').find('.drawer__inner').show();
      }else{
        if(jQuery('.header-item.header-item--icons').find('.cart-link__bubble').length>0){
          /*jQuery('html').removeClass('drawer--is-open');
          jQuery('.drawer.cart__drawer').removeClass('drawer--is-open');
          jQuery('.drawer.cart__drawer').removeAttr('tabindex');*/
          jQuery('.header-item.header-item--icons').find('.cart-link__bubble').removeClass('cart-link__bubble--visible');
          /*jQuery('.main-content').removeClass('has-after');
          jQuery('body').removeClass('drawer--is-open');*/
        }
      }
    }
    var itemHTML='';
    var strapCheck = 0;
    var cancerCount=0;
    let roseGoldPrice=0;
    let cartCancerAmount=0;
    let mainCancerAmount=(2.75*100);
    
    for (const item of cart.items) {
      let accessories_total = 0;
      let found_accessories = true;
      if(item.properties){
        Object.keys(item.properties).forEach(function(key) {
          if (key.indexOf('_Item') !== -1 && item.properties[key] !== '') {
            found_accessories = false;
            // split property value
            var accessory_parts = item.properties[key].split('#@#');
            // price index (same as Liquid [3])
            var accessory_variant_price = parseFloat(accessory_parts[3]) || 0;
            accessories_total += accessory_variant_price;
          }
        });
      }
      var mainbundlecls='';
      if(found_accessories == false){
        mainbundlecls=' has_bundle_main_card';
      }

      var currentVariantId=0;
      const isShippingProtection = (currentVariantId === item.variant_id);
      const isFreeGift = item.properties && item.properties._free_gift !== undefined;
      var imageUrl = item.featured_image && item.featured_image.url ? item.featured_image.url.replace(/(\.jpg|\.png|\.webp)/, '_300x300$1'): '';
      if(!item.properties._bundle){
        var bundle_title = item.product_title;
        var bundle_image = imageUrl;
        var bundle_description = '';
        if(found_accessories == false){
          if(item.properties._bundle_image){
            bundle_image = item.properties._bundle_image;
          }
          if(item.properties._bundle_description){
            bundle_description = item.properties._bundle_description;
          }
          if(item.properties._bundle_title){
            bundle_title = item.properties._bundle_title;
          }
        }

        itemHTML+='<div class="'+item.product_type+' cart__item'+mainbundlecls+'" data-key="'+item.key+'" data-keynew="1" data-pvid="'+item.variant_id+'"><div class="cart__item main_card_item" data-key="'+item.key+'" data-keynew="1" data-pvid="'+item.variant_id+'"><div class="cart__image">';
        itemHTML+='<a href="'+item.handle+'" style="height: 0; padding-bottom: 100.0%;">';
        var variantHandle = toHandle(item.variant_title);
        //console.log("variantHandle",item);
        if(jQuery('body').hasClass('rose_gold_active') && variantHandle.includes('rose-gold')) {
          itemHTML+='<div class="rose_gold_icon active" style="display: none;"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">';
          itemHTML+='<rect width="40" height="40" rx="20" fill="white"></rect>';
          itemHTML+='<path fill-rule="evenodd" clip-rule="evenodd" d="M27.8333 27.7507C22.4963 21.9304 19.0979 17.7751 17.1594 14.6794C15.9485 12.7507 15.2893 11.2175 15.1477 9.95769C14.2151 11.6374 13.7024 13.5075 13.6487 15.4557C13.6292 16.1784 14.2053 17.8483 17.0715 21.696C19.0686 24.3766 21.5588 27.2966 23.3753 29.4304C24.1467 30.3386 24.7962 31.0954 25.26 31.6667L27.8333 27.7507ZM19.4592 26.0856C18.4583 27.2917 17.4915 28.4294 16.637 29.4304C15.8655 30.3386 15.2161 31.0954 14.7522 31.6667L12.1741 27.7507C13.9514 25.8024 14.7473 24.8307 16.1487 23.1266C16.3049 22.9362 16.471 22.736 16.6418 22.5261C17.4915 23.6589 18.4485 24.8552 19.4592 26.0856ZM20.0012 11.1833C18.8391 11.1833 17.6917 11.5348 16.7249 12.1745C15.968 10.568 15.7776 9.36199 16.1389 8.4489C17.1057 7.31609 18.5071 6.66667 20.0012 6.66667C21.4954 6.66667 22.8967 7.31609 23.8635 8.4489C24.0784 9.02507 24.0003 10.0846 23.0383 12.0231C22.1204 11.4714 21.0754 11.1833 20.0012 11.1833ZM20.3723 17.7702C22.096 15.4216 23.3313 13.4391 24.0393 11.8766C24.4055 11.071 24.6399 10.3678 24.7424 9.75261C25.7483 11.4811 26.3049 13.4294 26.3587 15.4606C26.3782 16.154 25.846 17.7311 23.2337 21.2956C22.1497 20.0114 21.1975 18.8395 20.3723 17.7702Z" fill="#FF6A9C"></path>';
          itemHTML+='</svg></div>';
          cancerCount++;
        }
        itemHTML+='<img class="lazyautosizes lazyloaded" data-widths="[180, 360, 540]" data-aspectratio="" data-sizes="auto" alt="'+bundle_title+'" data-srcset="'+bundle_image+'" sizes="100px" srcset="'+bundle_image+'">';
        itemHTML+='<noscript><img class="lazyloaded" src="'+bundle_image+'" alt="'+bundle_title+'">';
        itemHTML+='</noscript></a></div>';
        itemHTML+='<div class="cart__item-details "><div class="cart__item-title">';
        itemHTML+='<a href="'+item.handle+'" class="cart__item-name">'+bundle_title+'</a>';
        if(item.variant_id != 50610556829983){
          if(found_accessories == false){
            itemHTML += '<div class="cart-variants-abtest bundle-description-abtest" style="display: none;">';
            itemHTML += '<span class="description">'+bundle_description;
            itemHTML += '</span></div>';
            itemHTML+='<div class="cart__item--variants bundle-description">';
            itemHTML+='<span class="description">'+bundle_description+'</span>';
            itemHTML += '</div>';
          }else{
            if(item.options_with_values.length>0){
              itemHTML += '<div class="cart-variants-abtest" style="display: none;">';
              for (var y = 0; y < item.options_with_values.length; y++) {
                var labelName = item.options_with_values[y].name;
                var valueVariant = item.options_with_values[y].value;
                if (labelName != 'Default Title') {
                  itemHTML += '<div class="abtest-value variant-' + generateHandle(labelName) + '">';
                  itemHTML += valueVariant;
                  // add separator except for last item
                  if (y != item.options_with_values.length - 1) {
                    itemHTML += '<span class="for-ab-test"> · </span>';
                  }
                  itemHTML += '</div>';
                }
              }
              itemHTML += '</div>';

              itemHTML+='<div class="cart__item--variants">';
              for(var y=0;y<item.options_with_values.length;y++){
                var labelName = item.options_with_values[y].name;
                var valueVariant = item.options_with_values[y].value;
                if(labelName != 'Default Title'){
                  itemHTML+='<div class="variant-label variant-'+generateHandle(labelName)+'"><label>'+labelName+':</label>';
                  itemHTML+='<span><img src="https://prettystraps.com/cdn/shop/files/rose-gold_50x50.png">'+valueVariant+'</span></div>';
                }
              }
              itemHTML+='</div>';
            }
          }
        }
        var trashIcon = 'display:none;';
        var minusIcon = 'display:block';
        var classTrash = '';
        if(item.quantity==1){
          var trashIcon = 'display:block;';
          var minusIcon = 'display:none';
          classTrash='js-qty__adjust--trash';
        }
      
        itemHTML+='</div>';
        var checkbundlecls = '';
        if(!found_accessories){
          checkbundlecls = 'has-bundle-product';
        }
        itemHTML+='<div class="cart__item-sub '+checkbundlecls+'">';
        if(found_accessories){
          itemHTML+='<div><div class="js-qty__wrapper">';
          itemHTML+='<label for="cart_updates_'+item.key+'" class="hidden-label">Quantity</label>';
          itemHTML+='<input type="text" id="cart_updates_'+item.key+'" name="updates[]" data-cartvid="'+item.variant_id+'" class="js-qty__num" value="'+item.quantity+'" min="0" pattern="[0-9]*" data-id="'+item.key+'" data-line="'+(y+1)+'">';
          itemHTML+='<button type="button" class="js-qty__adjust js-qty__adjust--minus '+classTrash+'" aria-label="Reduce item quantity by one">';

          itemHTML+='<svg style="'+trashIcon+'" class="quantity-trash" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 18" fill="none">';
          itemHTML+='<path d="M10.2833 6.50001L9.995 14M6.005 14L5.71667 6.50001M14.0233 3.82501C14.3083 3.86834 14.5917 3.91417 14.875 3.96334M14.0233 3.82501L13.1333 15.3942C13.097 15.8652 12.8842 16.3051 12.5375 16.626C12.1908 16.9469 11.7358 17.1251 11.2633 17.125H4.73667C4.26425 17.1251 3.80919 16.9469 3.46248 16.626C3.11578 16.3051 2.90299 15.8652 2.86667 15.3942L1.97667 3.82501M14.0233 3.82501C13.0616 3.6796 12.0948 3.56925 11.125 3.49417M1.97667 3.82501C1.69167 3.86751 1.40833 3.91334 1.125 3.96251M1.97667 3.82501C2.93844 3.67961 3.9052 3.56926 4.875 3.49417M11.125 3.49417V2.73084C11.125 1.74751 10.3667 0.927507 9.38333 0.896674C8.46135 0.867206 7.53865 0.867206 6.61667 0.896674C5.63333 0.927507 4.875 1.74834 4.875 2.73084V3.49417M11.125 3.49417C9.04477 3.33341 6.95523 3.33341 4.875 3.49417" stroke="#787878" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>';
          itemHTML+='</svg>';
          itemHTML+='<svg style="'+minusIcon+'" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20">';
          itemHTML+='<path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path>';
          itemHTML+='</svg>';
          itemHTML+='<span class="icon__fallback-text" aria-hidden="true">−</span></button>';
          itemHTML+='<button type="button" class="js-qty__adjust js-qty__adjust--plus" aria-label="Increase item quantity by one">';
          itemHTML+='<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path>';
          itemHTML+='</svg><span class="icon__fallback-text" aria-hidden="true">+</span></button></div></div>';
        }else{
          itemHTML+='<div class="cart__remove bundle_remove" style="display:block;">';
          itemHTML+='<input type="text" style="display:none;" id="cart_updates_'+item.key+'" name="updates[]" data-cartvid="'+item.variant_id+'" class="js-qty__num" value="'+item.quantity+'" min="0" pattern="[0-9]*" data-id="'+item.key+'" data-line="'+(y+1)+'">';
          itemHTML+='<button type="button" class="js-qty__adjust--minus js-qty__adjust--trash" aria-label="Reduce item quantity by one">';
          itemHTML+='<svg class="quantity-trash" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 18" fill="none">';
          itemHTML+='<path d="M10.2833 6.50001L9.995 14M6.005 14L5.71667 6.50001M14.0233 3.82501C14.3083 3.86834 14.5917 3.91417 14.875 3.96334M14.0233 3.82501L13.1333 15.3942C13.097 15.8652 12.8842 16.3051 12.5375 16.626C12.1908 16.9469 11.7358 17.1251 11.2633 17.125H4.73667C4.26425 17.1251 3.80919 16.9469 3.46248 16.626C3.11578 16.3051 2.90299 15.8652 2.86667 15.3942L1.97667 3.82501M14.0233 3.82501C13.0616 3.6796 12.0948 3.56925 11.125 3.49417M1.97667 3.82501C1.69167 3.86751 1.40833 3.91334 1.125 3.96251M1.97667 3.82501C2.93844 3.67961 3.9052 3.56926 4.875 3.49417M11.125 3.49417V2.73084C11.125 1.74751 10.3667 0.927507 9.38333 0.896674C8.46135 0.867206 7.53865 0.867206 6.61667 0.896674C5.63333 0.927507 4.875 1.74834 4.875 2.73084V3.49417M11.125 3.49417C9.04477 3.33341 6.95523 3.33341 4.875 3.49417" stroke="#787878" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>';
          itemHTML+='</svg></button></div>';
        }

        bundle_children_total = (accessories_total/100);
        let priceHtml = '';
        priceHtml += '<div class="cart__item-price-col text-right" data-price="' + item.final_line_price + '">';
        if (!found_accessories) {
          var bundle_display_price  = (item.final_price * item.quantity) + accessories_total;
          var bundle_original_price = (item.original_price * item.quantity) + accessories_total;

          if (item.original_price != item.final_price && item.discounted_price!=0) {
            priceHtml += '<span class="cart__price if cart__discount">' + Shopify.formatMoney(bundle_display_price) + '</span>';
          }else if(item.discounted_price==0){
            priceHtml += '<span class="cart__price free">' + Shopify.formatMoney(item.discounted_price) + '</span>';
          }else {
            priceHtml += '<span class="cart__price">' + Shopify.formatMoney(bundle_display_price) + '</span>';
          }
          if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
            item.line_level_discount_allocations.forEach(function(discount) {
              if (discount.amount != 0) {
                priceHtml += '<small class="cart__discount">' + discount.discount_application.title + ' (-' + Shopify.formatMoney(discount.amount) + ')</small>';
              }
            });
          }
        } else {
          if (item.original_line_price > item.final_line_price) {
            if (found_accessories) {
              //priceHtml += '<small class="cart__price cart__price--strikethrough">' + Shopify.formatMoney(item.original_line_price) + '</small>';
              priceHtml += '<span class="cart__price cart__discount">' + Shopify.formatMoney(item.final_line_price) + '</span>';
            } else {
              priceHtml += '<span class="cart__price else cart__discount">' + Shopify.formatMoney(bundle_display_price) + '</span>';
            }
          } else {
            priceHtml += '<span class="cart__price">' + Shopify.formatMoney(item.original_line_price) + '</span>';
          }

          if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
            item.line_level_discount_allocations.forEach(function(discount) {
              if (discount.amount != 0) {
                priceHtml += '<small class="cart__discount">' + discount.discount_application.title + ' (-' + Shopify.formatMoney(discount.amount) + ')</small>';
              }
            });
          }
        }
        priceHtml += '</div>';
        itemHTML += priceHtml;

        var compareAtPrice = await getComparePrice(item.variant_id);
        if (!found_accessories && (!compareAtPrice || compareAtPrice == 0)) {
          compareAtPrice = item.original_price;
        }

        if (compareAtPrice > 0) {
          let abtestPrice = '';
          abtestPrice += '<div class="cart__item-price-col ab-test-version text-right">';

          if (!found_accessories && item.final_line_price != 0) {
            var bundle_compare_price  = (compareAtPrice * item.quantity) + accessories_total;
            var bundle_final_price    = (item.original_price * item.quantity) + accessories_total;
            var bundle_original_price = (item.original_price * item.quantity) + accessories_total;
            console.log("bundle_final_price",item.original_price,bundle_final_price);
            if (bundle_compare_price > bundle_final_price) {
              //abtestPrice += '<small class="cart__price compare_price_abtest cart__price--strikethrough">' + Shopify.formatMoney(bundle_compare_price) + '</small>';
              abtestPrice += '<span class="cart__price main_price_abtest price_total cart__discount">' + Shopify.formatMoney(bundle_final_price) + '</span>';
            } else {
              abtestPrice += '<span class="cart__price normal_price_abtest">' + Shopify.formatMoney(bundle_original_price) + '</span>';
            }
            if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
              item.line_level_discount_allocations.forEach(function(discount) {
                if (discount.amount != 0) {
                  abtestPrice += '<small class="cart__discount">' + discount.discount_application.title + ' (-' + Shopify.formatMoney(discount.amount) + ')</small>';
                }
              });
            }
          } else {
            var compareTotal = compareAtPrice * item.quantity;

            if (compareTotal > item.final_line_price) {
              if (found_accessories) {
                abtestPrice += '<small class="cart__price compare_price_abtest cart__price--strikethrough">' + Shopify.formatMoney(compareTotal) + '</small>';
                abtestPrice += '<span class="cart__price main_price_abtest second cart__discount">' + Shopify.formatMoney(bundle_final_price) + '</span>';
              } else {
                abtestPrice += '<span class="cart__price main_price_abtest third cart__discount">' + Shopify.formatMoney(accessories_total) + '</span>';
              }
            } else {
              abtestPrice += '<span class="cart__price normal_price_abtest">' + Shopify.formatMoney(item.original_line_price) + '</span>';
            }
            if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
              item.line_level_discount_allocations.forEach(function(discount) {
                if (discount.amount != 0) {
                  abtestPrice += '<small class="cart__discount">' + discount.discount_application.title + ' (-' + Shopify.formatMoney(discount.amount) + ')</small>';
                }
              });
            }
          }

          abtestPrice += '</div>';
          itemHTML += abtestPrice;
        }

        itemHTML += '</div></div></div>';
        var accessoryHtml = '';
        if (found_accessories != true && item.properties) {
          var has_valid_discount = false;
          if (item.line_level_discount_allocations &&
              item.line_level_discount_allocations.length > 0) {

            item.line_level_discount_allocations.forEach(function(discount) {
              if (discount.amount > 0) {
                has_valid_discount = true;
              }
            });
          }
          accessoryHtml += '<div class="accessories_main_card">';

          /* ======================================================
            MAIN PRODUCT
          ====================================================== */

          accessoryHtml += '<div class="accessories_items">';

          if (imageUrl) {
            accessoryHtml +=
              '<div class="accessories_item_image">' +
              '<img src="' + imageUrl + '" alt="' + item.product_title + '" width="60" height="60">' +
              '</div>';
          }

          accessoryHtml += '<div class="accessories_item_info">';
          accessoryHtml += '<div class="accessories_item_title">' + item.product_title + '</div>';

          if (item.variant_title) {

            accessoryHtml += '<div class="accessories_item_variants">';

            var variantOptions = item.variant_title.split('|');

            variantOptions.forEach(function(option, index) {
              accessoryHtml += '<span class="accessories_variant_detail">' + option + '</span>';
              if (index !== variantOptions.length - 1) {
                accessoryHtml += ' • ';
              }
            });

            accessoryHtml += '</div>';
          }

          if (item.final_price == 0 && found_accessories) {
            accessoryHtml +=
              '<div class="accessories_price">' +
              '<span class="accessories_variant_price">' +
              Shopify.formatMoney(item.final_price) +
              '</span></div>';
          }

          accessoryHtml += '</div></div>';
          /* ======================================================
            ACCESSORY ITEMS
          ====================================================== */

          Object.keys(item.properties).forEach(function(key) {

            if (key.indexOf('_Item') !== -1 && item.properties[key]) {

              var accessory_parts = item.properties[key].split('#@#');

              var accessory_image         = accessory_parts[2];
              var accessory_title         = accessory_parts[0];
              var accessory_variants      = accessory_parts[1];
              var accessory_variant_price = accessory_parts[3];

              accessoryHtml += '<div class="accessories_items">';
              if (accessory_image) {
                accessoryHtml +=
                  '<div class="accessories_item_image">' +
                  '<img src="' + accessory_image + '" alt="' + accessory_title + '" width="60" height="60">' +
                  '</div>';
              }

              accessoryHtml += '<div class="accessories_item_info">';
              accessoryHtml += '<div class="accessories_item_title">' + accessory_title + '</div>';

              if (accessory_variants) {

                accessoryHtml += '<div class="accessories_item_variants">';

                var variantOptions = accessory_variants.split('|');

                variantOptions.forEach(function(option, index) {
                  accessoryHtml += '<span class="accessories_variant_detail">' + option + '</span>';
                  if (index !== variantOptions.length - 1) {
                    accessoryHtml += ' • ';
                  }
                });

                accessoryHtml += '</div>';
              }

              if ((found_accessories || has_valid_discount) && accessory_variant_price) {
                accessoryHtml +=
                  '<div class="accessories_price">' +
                  '<span class="accessories_variant_price">' +
                  Shopify.formatMoney(accessory_variant_price) +
                  '</span></div>';
              }

              accessoryHtml += '</div>'; // info
              accessoryHtml += '</div>'; // accessories_items (ACCESSORY)
            }
          });
          itemHTML += accessoryHtml+'</div>';
        }
        itemHTML +='</div>';

        if(item.product_type!="" && item.product_type!=undefined){
          var productTypes = item.product_type.toLowerCase();
          //console.log("productTypes",productTypes);
          if (productTypes.includes('strap')) {
            //console.log("iiiiii");
            discountTitle = 'Buy 1, Get 1 FREE';
          }
        }
        if(item.discounts.length>0){
          for(g=0;g<item.discounts.length;g++){
            var discountval = item.discounts[g].title;
            if(discountval === 'FLASH24' || discountval === 'BOGO-FLASH') {
              discountTitle = 'Buy 2, Get 3 FREE';
            } else if (discountval === 'B2G3FLASH' || discountval === 'B2G3-FLASH') {
              discountTitle = 'Buy 3, Get 4 FREE';
            }else if (discountval === 'B2G1') {
              discountTitle = 'Buy 2, Get 1 FREE';
            } else if (discountval === 'B3G4FLASH' || discountval === 'B3G4-FLASH') {
              discountTitle = '';
            }
          }
        }
        if(item.variant_title!=undefined){
          //console.log("productTitle",item);
          var productTitle = item.variant_title.toLowerCase();
          if(productTitle && productTitle.includes('rose gold')) {
            roseGoldPrice+=(parseFloat(item.discounted_price) * parseFloat(item.quantity));
            mainCancerAmount=(mainCancerAmount);
            cartCancerAmount+=(mainCancerAmount*item.quantity);
          }
        }
      }
      //console.log("p titles",roseGoldPrice);
      //container.insertAdjacentHTML('beforeend', itemHTML);
    }
    cartProgressBar(totalCents,discountTitle);
    
    if(cancerCount > 0){
      if(jQuery('.cart__drawer').find('.cancer-support-section.cancer-support-cart').length==0){
        var cancerHtml='';
        cancerHtml+='<div class="cancer-support-section cancer-support-cart" style="display: none;"><div class="cancer-support-header">';
        cancerHtml+='<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" class="ribbon-icon">';
        cancerHtml+='<path fill-rule="evenodd" clip-rule="evenodd" d="M16.6394 17.1805C12.7968 12.9898 10.3499 9.99805 8.9542 7.76914C8.08232 6.38047 7.60772 5.27656 7.50576 4.36953C6.83428 5.57891 6.46514 6.92539 6.42647 8.32812C6.4124 8.84844 6.82725 10.0508 8.89092 12.8211C10.3288 14.7512 12.1218 16.8535 13.4296 18.3898C13.9851 19.0438 14.4526 19.5887 14.7866 20L16.6394 17.1805ZM10.6101 15.9816C9.88936 16.85 9.19326 17.6691 8.57803 18.3898C8.02256 19.0438 7.55498 19.5887 7.221 20L5.36475 17.1805C6.64443 15.7777 7.21748 15.0781 8.22647 13.8512C8.33897 13.7141 8.4585 13.5699 8.58154 13.4187C9.19326 14.2344 9.88232 15.0957 10.6101 15.9816ZM11.0003 5.25195C10.1636 5.25195 9.3374 5.50508 8.64131 5.96563C8.09639 4.80898 7.95928 3.94063 8.21943 3.2832C8.91553 2.46758 9.92451 2 11.0003 2C12.0761 2 13.0851 2.46758 13.7812 3.2832C13.9358 3.69805 13.8796 4.46094 13.187 5.85664C12.5261 5.45937 11.7737 5.25195 11.0003 5.25195ZM11.2675 9.99453C12.5085 8.30352 13.398 6.87617 13.9077 5.75117C14.1714 5.17109 14.3401 4.66484 14.414 4.22187C15.1382 5.46641 15.539 6.86914 15.5776 8.33164C15.5917 8.83086 15.2085 9.96641 13.3276 12.5328C12.5472 11.6082 11.8616 10.7645 11.2675 9.99453Z" fill="#FF6A9C"></path></svg>';
        cancerHtml+='<h4 class="cancer-support-title">Thanks for supporting the cause!</h4></div>';
        cancerHtml+='<div class="cancer-support-subtitle"><p><strong>'+cartCancerAmount+'</strong> from your order goes to Breast Cancer support.</p></div></div>';
        jQuery('.cart__drawer').find('.offer-code-section').after(cancerHtml);
      }
    }
    if(firstload==""){
      if (jQuery('.cart__drawer .drawer__inner').find('.cart__items').length > 0 && itemHTML != '') {
        var $target = jQuery('.cart__drawer .drawer__inner').find('.cart__items');
      
        // Remove any previously appended blocks (add a class to target them)
        $target.find('.appended-item-html').remove();
        $target.find('.cart__item').remove();
        // Append the new HTML after .multi-step-form-2 and mark it with a class
        if(jQuery('body.offer-box-wrapper-v4').find('.main-delivery--progress-wrapper').length>0){
          $target.find('.main-delivery--progress-wrapper.code-bogo-offer-vfour').after('<div class="appended-item-html">' + itemHTML + '</div>');
        }else{
          $target.find('.multi-step-form-2').after('<div class="appended-item-html">' + itemHTML + '</div>');
        }
      }
      else if(jQuery('.cart__drawer').find('.drawer__cart-empty').length>0){
        jQuery('.cart__drawer').find('.drawer__cart-empty').show();
        jQuery('.drawer.cart__drawer').addClass('is-empty');
        jQuery('.cart__drawer').find('.drawer__inner').hide();
        $('.drawer.cart__drawer').find('.bogo-apex-3.appear--animation').hide();
      }
    }

    /****************************************************
     * BREAST CANCER SUPPORT ROSE GOLD PROGRESSBAR START
    ****************************************************/
    if(jQuery('body').hasClass('rose_gold_active')){
      //console.log("iiiiiin rose",roseGoldPrice);
      if(jQuery('.rose_gold_active').find('.cancer-support-section').length>0){
        //console.log("iiiiiin first");
        if(jQuery('.rose_gold_active').find('.cancer-support-section').find('.progress-bar-fill').length>0 && roseGoldPrice!=0){
          //console.log("iiiiiin not zero");
          var getCancerGoal = jQuery('.rose_gold_active').find('.cancer-support-section').find('.goal-amount').attr('data-goal-amount');
          var amountCalc = (roseGoldPrice/100);
          var remaining = getCancerGoal - amountCalc;
          if (remaining < 0) remaining = 0;

          var percent = (amountCalc / getCancerGoal) * 100;
          if (percent > 100) percent = 100;

          percent = Math.round(percent * 100) / 100;
          if(remaining>0){
            remaining = (remaining*100);
          }
          //console.log("percent",remaining,getCancerGoal,amountCalc);
          if(percent<100){
            jQuery('.rose_gold_active').find('.cancer-support-section').find('.progress-stats').show();
            jQuery('.rose_gold_active').find('.cancer-support-section').find('.amount-raised').text(Shopify.formatMoney(remaining));
          }else{
            jQuery('.rose_gold_active').find('.cancer-support-section').find('.progress-stats').hide();
          }
          jQuery('.rose_gold_active').find('.cancer-support-section').find('.progress-bar-fill').css('width',percent+'%');
        }
      }
      if(jQuery('.drawer.cart__drawer').find('.cancer-support-section.cancer-support-cart').length>0 && cartCancerAmount!=0){
        jQuery('.drawer.cart__drawer').find('.cancer-support-section.cancer-support-cart').find('.cancer-support-subtitle strong').text(Shopify.formatMoney(cartCancerAmount)); 
      }
    }
    /****************************************************
     * BREAST CANCER SUPPORT ROSE GOLD PROGRESSBAR END
    ****************************************************/
  });

  
  if(jQuery('.drawer.cart__drawer').find('#cart-items-goals').length>0){
    var getCount = parseInt(jQuery('.drawer.cart__drawer').find('#cart-items-goals').attr('data-count'));
    if(getCount==0){
      offerCodeHtml(1);
    }
  }
}
function toHandle(str) {
  if(str!=null){
    return str
    .toLowerCase()                 // make lowercase
    .trim()                        // remove spaces from start & end
    .replace(/[^a-z0-9\s-]/g, '')  // remove special characters
    .replace(/\s+/g, '-')          // replace spaces with hyphens
    .replace(/-+/g, '-');          // collapse multiple hyphens
  }
}


function bogoOfferShowhide(){
  fetch(
    "https://" + window.location.hostname + "/browsing_context_suggestions.json"
  )
  .then((res) => res.json())
  .then((r) => {
    console.log("country--->", r.detected_values.country.name)
    //if (r.detected_values.country.name == "United States") {
      $('.offer-code-section').show();
      $('.offer-code-section').removeClass("hide__bogo");
    /*} else {
      $('.offer-code-section').hide();
    }*/
    if (r.detected_values.country.name == "United States") {
      if (document.querySelector("#product-shoppay-placement")) {
        document.querySelector("#afterpay-placement").style.display = "flex";
      }
    } else if (r.detected_values.country.name == "Australia") {
      if (document.querySelector("#product-shoppay-placement")) {
        document.querySelector("#afterpay-placement").style.display = "flex";
      }
    } else if (r.detected_values.country.name == "United Kingdom") {
      if (document.querySelector("#product-shoppay-placement")) {
        document.querySelector("#afterpay-placement").style.display = "flex";
      }
    } else if (r.detected_values.country.name == "Canada") {
      if (document.querySelector("#product-shoppay-placement")) {
        document.querySelector("#afterpay-placement").style.display = "flex";
      }
    } else if (r.detected_values.country.name == "New Zealand") {
      if (document.querySelector("#afterpay-placement")) {
        document.querySelector("#afterpay-placement").style.display = "flex";
      }
    } else {
      if (document.querySelector("#afterpay-placement")) {
        document.querySelector("#afterpay-placement").style.display = "none";
      }
    }
  });
}

function cartDrawerClose(){
  jQuery('html').removeClass('drawer--is-open');
  jQuery('html').removeClass('js-drawer-open');
  jQuery('.drawer.cart__drawer').removeClass('drawer--is-open');
  jQuery('.drawer.cart__drawer').removeAttr('tabindex');
  if(jQuery('.drawer.cart__drawer').find('.cart__item').length==0){
    jQuery('.header-item.header-item--icons').find('.cart-link__bubble').removeClass('cart-link__bubble--visible');
  }
  jQuery('.main-content').removeClass('has-after');
  jQuery('body').removeClass('drawer--is-open');
}

function cartDrawerOpen() {
  jQuery('html').addClass('drawer--is-open js-drawer-open');
  jQuery('body').addClass('drawer--is-open');
  jQuery('.main-content').addClass('has-after');
  jQuery('.drawer.cart__drawer')
    .addClass('drawer--is-open')
    .attr('tabindex', '-1');

  // Optional: Show cart bubble if items exist
  if (jQuery('.drawer.cart__drawer').find('.cart__item').length > 0) {
    jQuery('.header-item.header-item--icons').find('.cart-link__bubble').addClass('cart-link__bubble--visible');
  }
}


jQuery(document).on("click",".cart__drawer .drawer__close-button.js-drawer-close",function(){
  cartDrawerClose();
});

jQuery(document).on('click','.main-content.has-after', function(event) {
  //console.log("calll");
  if (!$(event.target).closest('#CartDrawer').length) {
    //console.log("length not");
    cartDrawerClose();
  }
});
/************************ CART DRAWER JS END *************************/

/* :::::::::::::::::::::::::::::: PDP PAGE FOR UPSELL PRODUCT JS START ::::::::::::::::::::::::::::::::*/
/*jQuery(document).ready(function(){
  //console.log("check prettry starps",jQuery('.page-content--product').find('.upsell_product.common_upsell_pdp').is(':visible'));
  if(jQuery('.page-content--product').find('.upsell_product.common_upsell_pdp').is(':visible')){
    jQuery(".product-block.buy-atc .add-to-cart").on("click",function(e){
      if(jQuery('.template-product').find('.upsell_product_add').length>0){
        if(jQuery('.template-product').find('.upsell_product_add').val()!="" && jQuery('.template-product').find('.upsell_product_add').val()!=undefined){
          var variantUpsellId = jQuery('.template-product').find('.upsell_product_add').val();
          setTimeout(function(){
            addTocartUpsell(variantUpsellId);
          },800);
        }
      }
    });
  }
});*/
jQuery(document).on("change",".upsell_product .upsell_checkbox",function(){
    var variantId='';
    if(jQuery(this).is(':checked')){
      variantId = $(this).closest('.product_cta').data('vid');
    }
    if($(this).parent('.switch').length>0){
      $(this).parent('.switch').toggleClass('active-checkbox');
    }
    if(variantId!=undefined){
      jQuery('.template-product').find('.upsell_product_add').val(variantId);
    }
});
jQuery(document).on("click",".upsell_product .upsell_btn",function(){
  var variantId='';
  jQuery(this).toggleClass('upsell_added');
  if(jQuery(this).hasClass('upsell_added')){
    variantId = jQuery(this).parent('div').attr('data-vid');
  }
  if(variantId!=undefined){
    jQuery('.template-product').find('.upsell_product_add').val(variantId);
  }
});
function addTocartUpsell(variantId){
  console.log("up sell callll",variantId);
   $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: variantId,
      },
      dataType: "json",
      success: function (data) {
        if(jQuery('.page-content--product').find('.upsell_product.common_upsell_pdp').is(':visible')){
          jQuery('.page-content--product').find('.product_cta').find('.upsell_checkbox').prop("checked",false);
          jQuery('.page-content--product').find('.product_cta').find('.upsell_btn').removeClass("upsell_added");
          if(jQuery('.page-content--product').find('.product_cta').find('.switch.active-checkbox').length>0){
            jQuery('.page-content--product').find('.product_cta').find('.switch.active-checkbox').trigger("click");
          }
          jQuery('.template-product').find('.upsell_product_add').val('');
        }
        setTimeout(function(){
          updateCartTotal();
        },200);
      },
      error: function (XMLHttpRequest, textStatus) {
        alert(textStatus);
      },
    });
  }
/* :::::::::::::::::::::::::::::: PDP PAGE FOR UPSELL PRODUCT JS END ::::::::::::::::::::::::::::::::::*/


//SHOP THE LOOK FRONT (SHOWCASE-SLIDER.LIQUID) ADD TO CART JS START
jQuery(document).on("change",".shop_look_add__select_custom",function () {
  var productId = jQuery(this).parent('div').attr('data-product-id');
  var selectObj = $(this);
  selectObj.hide();
  //$(this).parent().find(".add__custom_loader").show();
  var loaderObj = $(this).parent().find('.common-loader-atc');
  loaderObj.show();
  var dataType = [];
  var data = {};
  data["id"] = parseInt($(this).val());
  data["quantity"] = 1;
  dataType.push(data);
  const newData = {
    items: dataType,
  };
  $(this).val("");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: newData,
    dataType: "json",
    success: function (data) {
      //setTimeout(function () {
      setTimeout(function(){
        selectObj.show();
        //$(this).parent().find(".add__custom_loader").hide();
        loaderObj.hide();
      },100);
        /*var cart = new theme.CartDrawer();
        cart.init();
        cart.open();*/
        updateCartTotal();
        offerCodeHtml(1);
        //defaultShowProgress();
        if(productId!=undefined){
          jQuery('[cart-product--id="'+productId+'"]').hide();
        }
      //}, 1550);
    },
  });

  /*setTimeout(function () {
    $(".add__select_custom").show();
    $(".add__custom_loader").hide();
  }, 1550);*/
});

//CLOSE ICON CLICK EVENT START
jQuery(document).on('click','.showcase-card-products .showcase-close-icon',function(){
  jQuery(this).parent('div').removeClass('open');
  jQuery(this).parent().parent('div').find('.product-toggle-btn').show();
});
//CLOSE ICON CLICK EVENT END
//SHOP THE LOOK FRONT (SHOWCASE-SLIDER.LIQUID) ADD TO CART JS END


/* :::::::::::::::::::::::::::::: PDP PAGE FOR SHOP THE LOOK PRODUCT ATC BUTTON JS ::::::::::::::::::::::::::::::::::*/
jQuery(document).on("click", ".mps-lookbook-product .talb-plist_btn", function () {
  var $wrapper = jQuery(this).closest('.mps-lookbook-product');
  var $grid = $wrapper.find('.productlook-grid');
  if ($grid.find('.atc_checkbox:checked').length === 0) {
    console.log('No checkbox selected');
    return;
  }
  var variantData = [];
  $grid.find('.atc_checkbox:checked').each(function () {
    var getId = jQuery(this).attr('id');
    console.log("getId",getId);
    var $addToCart = jQuery('.product_lookcard').find('.product_lookcontent.'+getId).find('.product-block.buy-atc').find('.product-single__variants');
    console.log("lenght",$addToCart.length)
    if ($addToCart.length) {
      var selectedVariantId = $addToCart.find("option:selected").val();
       variantData.push({
        id: selectedVariantId,
        quantity:1
      });
    }
  });
  if(variantData.length>0){
    jQuery(this).addClass('btn--loading');
    setTimeout(function(){
      addTocartLookup(variantData);
    },100);
  }
});

function resetLookupCheckbox() {
  if(jQuery('.productlook-grid').find('.atc_checkbox:checked').length>0){
    jQuery('.productlook-grid').find('.atc_checkbox:checked').each(function() {
      jQuery(this).parent('div').find('.atc_checkbox_label').trigger('click');
    });
  }
}

function loaderHideLookup(){
  setTimeout(function(){
    if(jQuery('.productlook-grid').find('.talb-plist_btn').hasClass('btn--loading')){
      jQuery('.productlook-grid').find('.talb-plist_btn').removeClass('btn--loading');
    }
  },2000);
}

function addTocartLookup(itemData){
   $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ items: itemData }),
      success: function (data) {
        resetLookupCheckbox();
        loaderHideLookup();
        setTimeout(function(){
          updateCartTotal();
        },200);
      },
      error: function (XMLHttpRequest, textStatus) {
        loaderHideLookup();
        alert(textStatus);
      },
    });
  }
/* :::::::::::::::::::::::::::::: PDP PAGE FOR SHOP THE LOOK PRODUCT ATC BUTTON JS ::::::::::::::::::::::::::::::::::*/
/* :::::::::::::::::::::::::::::: CART DRAEWER CONVERT UPSELL FOR PRODUCT ADD TO CART START CODE ::::::::::::::::::::::::::::::::::*/
document.addEventListener("DOMContentLoaded", async function () {

  // =========================
  // SWIPER INSTANCES
  // =========================

  const swiperVfive = new Swiper('.cart_upsell_swiper_vfive', {
    slidesPerView: 1.2,
    spaceBetween: 24,
    navigation: {
      nextEl: ".cart_upsell_vfive .cu_slider_arrow_next",
      prevEl: ".cart_upsell_vfive .cu_slider_arrow_prev",
    },
    scrollbar: {
      el: '.cart_upsell_swiper_vfive .swiper-scrollbar',
      draggable: true,
    },
  });

  const swiperVsix = new Swiper('.cart_upsell_swiper_vsix', {
    slidesPerView: 2.4,
    spaceBetween: 10,
    scrollbar: {
      el: '.cart_upsell_swiper_vsix .swiper-scrollbar',
      draggable: true,
    },
  });

  // TAB
  const tabs = document.querySelectorAll("ul.cart_upsell_tabs li");
  tabs.forEach(function(tab) {
    tab.addEventListener("click", function () {
      const tab_id = this.getAttribute("data-tab");
      document.querySelectorAll("ul.cart_upsell_tabs li").forEach(function(item) {
        item.classList.remove("current");
      });
      document.querySelectorAll(".cart_upsell_swiper_vsix.tab-content").forEach(function(content) {
        content.classList.remove("current");
      });
      this.classList.add("current");
      document.getElementById(tab_id).classList.add("current");

      // tab change થાય ત્યારે swiper update
      if (swiperVsix) {
        if (Array.isArray(swiperVsix)) {
          swiperVsix.forEach(s => s.update());
        } else {
          swiperVsix.update();
        }
      }
    });
  });

  // =========================
  // SWIPER UPDATE HELPER
  // =========================
  function updateAllSwipers() {
    [swiperVfive, swiperVsix].forEach(function(swiper) {
      if (!swiper) return;
      if (Array.isArray(swiper)) {
        swiper.forEach(s => { if (s && s.update) s.update(); });
      } else {
        if (swiper.update) swiper.update();
      }
    });
  }

  // =========================
  // CART FETCH
  // =========================
  async function getCartProductIds() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      return cart.items.map(item => String(item.product_id));
    } catch(e) {
      return [];
    }
  }

  // =========================
  // UPSELL VISIBILITY
  // =========================
  async function updateUpsellVisibility() {
    const cartProductIds = await getCartProductIds();
    let visibleCount = 0;

    const variantClasses = ['cart_upsell_vfive', 'cart_upsell_vsix', 'cart_upsell_veight'];
    const mainBlock = document.querySelector('.cart_upsell_variants');

    // Active block find karo
    let activeBlock = null;
    if (mainBlock) {
      const markedBlock = mainBlock.querySelector('[data-upsell-active="true"]');
      if (markedBlock) {
        activeBlock = markedBlock;
      } else {
        variantClasses.forEach(function(cls) {
          const block = mainBlock.querySelector('.' + cls);
          if (!block) return;
          const inlineDisplay = block.style.getPropertyValue('display');
          block.style.removeProperty('display');
          const computedDisplay = window.getComputedStyle(block).display;
          if (inlineDisplay) {
            block.style.setProperty('display', inlineDisplay, 'important');
          }
          if (computedDisplay !== 'none') {
            activeBlock = block;
            block.setAttribute('data-upsell-active', 'true');
          }
        });
      }
    }

    if (!activeBlock) {
      updateAllSwipers();
      return;
    }

    const isVsix = activeBlock.classList.contains('cart_upsell_vsix');

    if (isVsix) {
      // vsix: dareek tab na cards check karo separately
      const allTabs = activeBlock.querySelectorAll('.tab-content');
      let atLeastOneTabVisible = false;

      allTabs.forEach(function(tabContent) {
        let tabVisibleCount = 0;

        tabContent.querySelectorAll('.cart_upsell_card[data-pid]').forEach(function(card) {
          const pid = String(card.getAttribute('data-pid'));
          const slide = card.closest('.cart_upsell_slide, .swiper-slide');
          const target = slide || card;

          if (cartProductIds.includes(pid)) {
            target.style.display = 'none';
          } else {
            target.style.display = '';
            tabVisibleCount++;
          }
        });

        // Aa tab visible chhe ke nahi
        if (tabVisibleCount > 0) {
          atLeastOneTabVisible = true;
          visibleCount += tabVisibleCount;
        }

        // Tab na corresponding tab-link show/hide
        const tabId = tabContent.getAttribute('id');
        const tabLink = activeBlock.querySelector('.tab-link[data-tab="' + tabId + '"]');
        // if (tabLink) {
        //   tabLink.style.display = tabVisibleCount > 0 ? '' : 'none';
        // }

        // Jya tab active chhe ane visible nathi, to next visible tab switch karo
        if (tabContent.classList.contains('current') && tabVisibleCount === 0) {
          // Next visible tab find karo
          const nextVisibleTab = Array.from(allTabs).find(function(t) {
            return t !== tabContent && t.querySelectorAll('.cart_upsell_card[data-pid]').length > 0;
          });
          if (nextVisibleTab) {
            // Current tab remove karo
            tabContent.classList.remove('current');
            const oldTabId = tabContent.getAttribute('id');
            const oldLink = activeBlock.querySelector('.tab-link[data-tab="' + oldTabId + '"]');
            if (oldLink) oldLink.classList.remove('current');

            // New tab show karo
            nextVisibleTab.classList.add('current');
            const newTabId = nextVisibleTab.getAttribute('id');
            const newLink = activeBlock.querySelector('.tab-link[data-tab="' + newTabId + '"]');
            if (newLink) newLink.classList.add('current');
          }
        }
      });

      // Jya koi pan tab ma visible products hoy to mainBlock show karo
      if (atLeastOneTabVisible) {
        activeBlock.style.setProperty('display', 'block', 'important');
        mainBlock.style.setProperty('display', 'block', 'important');
      } else {
        activeBlock.style.setProperty('display', 'none', 'important');
        mainBlock.style.setProperty('display', 'none', 'important');
      }

    } else {
      // vfive / veight — normal logic
      activeBlock.querySelectorAll('.cart_upsell_card[data-pid]').forEach(function(card) {
        const pid = String(card.getAttribute('data-pid'));
        const slide = card.closest('.cart_upsell_slide, .swiper-slide');
        const target = slide || card;

        if (cartProductIds.includes(pid)) {
          target.style.display = 'none';
        } else {
          target.style.display = '';
          visibleCount++;
        }
      });

      if (visibleCount === 0) {
        activeBlock.style.setProperty('display', 'none', 'important');
        mainBlock.style.setProperty('display', 'none', 'important');
      } else {
        activeBlock.style.setProperty('display', 'block', 'important');
        mainBlock.style.setProperty('display', 'block', 'important');
      }
    }

    updateAllSwipers();
  }

  // =========================
  // updateCartTotal OVERRIDE
  // =========================
  function overrideUpdateCartTotal() {

    if (window.__cartTotalOverridden) return;

    if (typeof window.updateCartTotal === 'function') {

      const _original = window.updateCartTotal;

      window.updateCartTotal = async function() {
        _original.apply(this, arguments);
        await updateUpsellVisibility();
      };

      window.__cartTotalOverridden = true;
      console.log('updateCartTotal overridden ✓');
    }
  }

  let checkCount = 0;
  const checkInterval = setInterval(function() {
    checkCount++;
    overrideUpdateCartTotal();
    if (window.__cartTotalOverridden || checkCount > 100) {
      clearInterval(checkInterval);
    }
  }, 100);

  // =========================
  // FETCH INTERCEPT
  // =========================
  const _originalFetch = window.fetch;

  window.fetch = async function(...args) {
    const url = args[0] || '';
    const urlStr = typeof url === 'string'
      ? url
      : url instanceof Request
        ? url.url
        : '';

    const result = await _originalFetch.apply(this, args);

    if (
      urlStr.includes('/cart/add') ||
      urlStr.includes('/cart/change') ||
      urlStr.includes('/cart/remove') ||
      urlStr.includes('/cart/update') ||
      urlStr.includes('/cart/clear')
    ) {
      result.clone().json().then(async function() {
        await updateUpsellVisibility();
      }).catch(function(){});
    }

    return result;
  };

  // =========================
  // XHR INTERCEPT
  // =========================
  const _originalXHROpen = XMLHttpRequest.prototype.open;
  const _originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return _originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function() {
    const url = this._url || '';

    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/remove') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    ) {
      this.addEventListener('load', async function() {
        await updateUpsellVisibility();
      });
    }

    return _originalXHRSend.apply(this, arguments);
  };

  // =========================
  // ATC HANDLER
  // =========================
  async function handleAtcClick(btn) {

    if (btn.classList.contains('atc--loading')) return;

    const card = btn.closest('.cart_upsell_card');

    // Always get latest variant id from button
    let variantId = btn.getAttribute('data-vid');

    // fallback
    if (!variantId && card) {

      const select = card.querySelector(
        'select.select_variants, select[name="id"], .product-variant-select'
      );

      if (select && select.value) {
        variantId = select.value;
      }
    }

    if (!variantId || variantId === '') {
      alert('Please select a variant.');
      return;
    }

    btn.classList.add('atc--loading');

    try {

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      const data = await res.json();

      console.log('Added Variant ID:', variantId);
      console.log(data);

      if (data.id) {

        if (typeof window.updateCartTotal === 'function') {
          window.updateCartTotal();
        }

        await updateUpsellVisibility();
      }

    } catch (e) {

      console.error('ATC Error:', e);

    } finally {

      btn.classList.remove('atc--loading');

    }
  }

  function atcClickHandler() {
    handleAtcClick(this);
  }

  function bindAtcButtons() {
    document.querySelectorAll(
      '.cart_upsell_card .cup_atc_btn, .cart_upsell_atc'
    ).forEach(function(btn) {
      btn.removeEventListener('click', atcClickHandler);
      btn.addEventListener('click', atcClickHandler);
    });
  }

  // =========================
  // INIT
  // =========================
  bindAtcButtons();
  await updateUpsellVisibility();

  // vfive color swatch click handler
  document.querySelectorAll('.cart_upsell_vfive .color-swatch-ci').forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      const pid = this.getAttribute('data-pid');
      const variantId = this.getAttribute('data-variant-id');
      const variantImage = this.getAttribute('data-variant-image');
      const card = this.closest('.cart_upsell_card');

      if (!card) return;

      // Active swatch update karo
      card.querySelectorAll('.color-swatch-ci').forEach(function(s) {
        s.classList.remove('active');
      });
      this.classList.add('active');

      // Banner image update karo
      if (variantImage) {
        const img = card.querySelector('.cart_upsell_banner img');
        if (img) img.src = variantImage;
      }

      // Size select — selected color na variants filter karo
      const sizeSelect = card.querySelector('.product-variant-select');
      if (sizeSelect && variantId) {

        // Aa color ni sathe match thata variants find karo
        const colorValue = this.getAttribute('data-value');

        // Dareek option check karo — aa color match kare evu variant select karo
        Array.from(sizeSelect.options).forEach(function(option) {
          if (option.value === variantId) {
            sizeSelect.value = variantId;
          }
        });

        // Size select ma color match karta variants j show karo
        // (optional: agar size options color wise filter karva hoy to)
      }

      // ATC button par variant id set karo
      const atcBtn = card.querySelector('.cup_atc_btn');
      if (atcBtn) {
        atcBtn.setAttribute('data-vid', variantId);
      }
    });
  });

  // vfive — color swatch + size select → correct variant find karo
  function initVfiveColorSwatches() {
    document.querySelectorAll('.cart_upsell_vfive .cart_upsell_card').forEach(function(card) {

      const swatches = card.querySelectorAll('.color-swatch-ci');
      const sizeSelect = card.querySelector('.product-variant-select');
      const atcBtn = card.querySelector('.cup_atc_btn');
      const bannerImg = card.querySelector('.cart_upsell_banner img');

      function updateVariant() {

        const selectedVariantId = sizeSelect ? sizeSelect.value : null;

        // Active color auto set based on selected variant
        if (selectedVariantId) {

          swatches.forEach(function(swatch) {

            const swatchVariantId = swatch.getAttribute('data-variant-id');

            swatch.classList.remove('active');

            if (swatchVariantId === selectedVariantId) {
              swatch.classList.add('active');
            }

          });
        }

        const activeSwatch = card.querySelector('.color-swatch-ci.active');

        const selectedColor = activeSwatch
          ? activeSwatch.getAttribute('data-value')
          : null;

        const selectedSize = sizeSelect
          ? sizeSelect.options[sizeSelect.selectedIndex]
          : null;

        const selectedSizeValue = selectedSize
          ? selectedSize.getAttribute('data-value')
          : null;

        // Color + size match
        if (selectedColor && selectedSizeValue && sizeSelect) {

          Array.from(sizeSelect.options).forEach(function(option) {

            const optTitle = option.getAttribute('data-vtitle') || '';

            if (
              optTitle.toLowerCase().includes(selectedColor.toLowerCase()) &&
              optTitle.toLowerCase().includes(selectedSizeValue.toLowerCase())
            ) {

              sizeSelect.value = option.value;

              if (atcBtn) {
                atcBtn.setAttribute('data-vid', option.value);
              }

            }

          });

        }

      }

      // Color swatch click
      swatches.forEach(function(swatch) {
        swatch.addEventListener('click', function() {
          // Active update
          swatches.forEach(function(s) { s.classList.remove('active'); });
          this.classList.add('active');

          // Image update
          const variantImage = this.getAttribute('data-variant-image');
          if (variantImage && bannerImg) {
            bannerImg.src = variantImage;
          }

          updateVariant();
        });
      });

      // Size select change
      if (sizeSelect) {
        sizeSelect.addEventListener('change', function() {
          // Selected size na option thi image update karo
          const selectedOpt = this.options[this.selectedIndex];
          const vImage = selectedOpt ? selectedOpt.getAttribute('data-vimage') : null;
          if (vImage && bannerImg) {
            bannerImg.src = vImage;
          }
          // ATC button update
          if (atcBtn) atcBtn.setAttribute('data-vid', this.value);
          updateVariant();
        });
      }
      if (swatches.length > 0) {
        swatches[0].classList.add('active');
      }
      // Initial state set karo
      updateVariant();
    });
  }

  // DOMContentLoaded ma call karo
  document.addEventListener('DOMContentLoaded', function() {
    initVfiveColorSwatches();
  });
});
/* :::::::::::::::::::::::::::::::::: CART DRAEWER CONVERT UPSELL FOR PRODUCT ADD TO CART END CODE ::::::::::::::::::::::::::::::::::*/

/* :::::::::::::::::::::::::::::::::: CART DRAWER CLOSE ON BODY CLICK START CODE ::::::::::::::::::::::::::::::::::*/

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (evt) {
    var cartDrawer = document.querySelector("#CartDrawer");
    //console.log("cartdddd",cartDrawer);
    if (!cartDrawer || !cartDrawer.classList.contains("drawer--is-open")) return;
    if (cartDrawer.contains(evt.target)) return;
    if (evt.target.closest('[data-drawer-open="cart"], a[href="#CartDrawer"]')) return;
    document.dispatchEvent(new CustomEvent("cart:close"));
  });
});
/* :::::::::::::::::::::::::::::::::: CART DRAWER CLOSE ON BODY CLICK START CODE ::::::::::::::::::::::::::::::::::*/